  <!-- https://xd.adobe.com/view/51c57223-a5f2-4ed2-bc51-fe244066945f-0496/screen/3e888227-7a25-40d9-a27f-0f4cecee94e6/ -->
  <!-- https://xd.adobe.com/view/a28a3814-b5c5-4b4e-aebb-42469f791299-f7d9/screen/6350d940-4664-495a-878e-135b9b0de0e8/specs/ 
  https://docs.google.com/presentation/d/1LNKiWCnSnWxyGedgNqEstg_XmGqG_6tzRaAmqh1zUdQ/edit#slide=id.g147cd819b91_0_6
  https://docs.google.com/presentation/d/16eLRzVsOm-AAYxBKGzoKeFsL6DU5jSO5JGMpXS9phH8/edit#slide=id.g1f2220bf01e_0_7 old design
  https://docs.google.com/document/d/19wkBrLhE3YJKMIVEqtdCXHzOfc1pL2-b_UphTNKqqDo/edit - kan ikke
  https://xd.adobe.com/view/f344cbd5-67ae-4ef0-8cfc-8b8f917363a3-a617/screen/1052a692-9f86-4b17-8b19-dde688332a0f/
  https://docs.google.com/presentation/d/18i-61r_Oyd1RSZ2gVCbacxJQ64v6JhQiC0gYr8tGnNs/edit#slide=id.g1e66108d080_1_0
  https://xd.adobe.com/view/d3a0016d-0148-4820-871d-6757f32740ff-86f3/
  https://xd.adobe.com/view/02aeb373-20ee-4722-935c-66a029645b6d-57fd/
  https://xd.adobe.com/view/7a7c9ae8-0b09-4da3-8004-737b902d9849-2f2f/specs/
  https://xd.adobe.com/view/20818fde-c85c-40d5-a672-b2651110f177-75d2/ - mobile
  https://docs.google.com/presentation/d/17jyzC7801QF3CLG9w0gwZxDq-c9DCdAFYvUv_UeH25Q/edit#slide=id.p  issues
  https://docs.google.com/presentation/d/1MK4ZMITWJGMF4Cfm3DvWHVrx1jtoSg997hw17GXjEGI/edit#slide=id.p user guide
  https://docs.google.com/presentation/d/19vXlTo4M1jsV2DizVeHqLg-7gRWuy4t09IL8BsH6JiY/edit#slide=id.p  kanikke latest
  https://docs.google.com/presentation/d/1MRCJgUMpozZJPWl7P5y1qKx2HXUH5LQpGpp3li2XhCw/edit?pli=1#slide=id.p Dine notater
  https://xd.adobe.com/view/c6fa2e7c-6822-4379-91db-03c7de29a5b4-93a9/screen/6f644158-179f-4b26-afee-2be0371fb59a/ tender flow app
  -->
<template>
    <main id="mycustomer">
      <div class="clearfix gibson mb2">
        <div class="col-12 px0">
          <div class="clearfix py3">
            <!-- mobile header setup -->
            <div class="col-12 px0" v-if="showMobile">
              <p class="h4 semi-bold line-height-2 my2">Dine kunder</p>
              <p class="h5 regular darkblue gibson line-height-golden mb3">
                Dit samlede overblik over alle dine kunder - både fra Markedspladsen, din profil-side og Mester til Mester.<br><br>
                Se historik, information og send tilbud til kunden med det samme herfra - hurtigt og enkelt.
              </p>
              <!-- mobile search input -->
              <div class="flex justify-start items-center py1 border muted-border mediumgrey shadow mb2">
                <div class="flex-none px2">
                  <svg class="relative" style="top:3px;" width="18" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path class="st0" d="M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"/></svg>
                </div>
                <input class="searchBox gibson h4 darkblue regular mb0 p2 pl0" type="search" name="search" v-model="search" placeholder="Søg efter" style="background:transparent;">
              </div>
              <!-- mobile sorting and filter buttons -->
              <div class="col-12 px0 flex justify-start items-center mt3">
                <div class="col-6 pr1 pl0">
                  <button v-b-toggle.webCustomers class="col-12 p2 gibson dark-button not-rounded flex justify-center items-center line-height-1">
                    <span class="h5 mb0">Sortér</span>
                    <span class="relative ml2" style="top:4px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </button>
                </div>
                <div class="col-6 px0">
                  <button v-b-toggle.m2m class="col-12 p2 gibson dark-button not-rounded flex justify-center items-center line-height-1">
                    <span class="h5 mb0 mr2">Filter</span>
                    <span class="when-closed">
                      <span class="relative" style="top:3px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </span>
                    <span class="flex-none when-opened">
                      <span class="relative" style="top:3px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                      </span>
                    </span>
                  </button>
                </div>
              </div>
              <!-- mobile filter collapse -->
              <b-collapse id="m2m">
                <div class="clearfix my3">
                  <div class="col-12 px0 flex justify-between items-center">
                    <p class="h4 darkblue gibson line-height-3">
                      Vælg
                    </p>
                    <button v-b-toggle.m2m class="white-button border-none not-rounded gibson">
                      <span>
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="col-12 px0 flex justify-start items-center my2">
                    <div>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortByStatus" v-model="status" name="sortByStatus" value="10">
                        <span class="ml1 h5 regular relative m0">Mester til Mester</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortByHaveWork" v-model="status" name="sortByHaveWork" value="9">
                        <span class="ml1 h5 regular relative m0">private</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortBNeedeWork" v-model="status" name="sortByNeedWork" value="8">
                        <span class="ml1 h5 regular relative m0">Med Tilbud</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortBNeedeWork" v-model="status" name="sortByNeedWork" value="7">
                        <span class="ml1 h5 regular relative m0">Uden Tilbud</span>
                      </b-form-checkbox>
                      <div class="clearfix"><hr></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortByStatus" v-model="status" name="sortByStatus" value="0">
                        <span class="ml1 h5 regular relative m0">Ny opgave</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortByHaveWork" v-model="status" name="sortByHaveWork" value="1">
                        <span class="ml1 h5 regular relative m0">I dialog</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortBNeedeWork" v-model="status" name="sortByNeedWork" value="2">
                        <span class="ml1 h5 regular relative m0">Tilbud er sendt</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortBNeedeWork" v-model="status" name="sortByNeedWork" value="3">
                        <span class="ml1 h5 regular relative m0">Vandt opgaven</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortBNeedeWork" v-model="status" name="sortByNeedWork" value="4">
                        <span class="ml1 h5 regular relative m0">Opgaven er udført</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox class="line-height-1 mb2" id="sortBNeedeWork" v-model="status" name="sortByNeedWork" value="5">
                        <span class="ml1 h5 regular relative m0">Vandt ikke opgaven</span>
                      </b-form-checkbox>
                      <b-form-checkbox class="line-height-1 mb2" id="sortByquickoffer" v-model="status" name="sortByquickoffer" value="100" >
                        <span class="ml1 h5 regular relative m0">Kan ikke afgive tilbud</span>
                      </b-form-checkbox>
                      <b-form-checkbox class="line-height-1 mb2" id="ikkerelevant" v-model="status" name="ikkerelevant" value="12" >
                      <span class="ml0 h6 regular relative" style="top:-3px;">ikke relevant</span>
                    </b-form-checkbox>
                    </div>
                  </div>
                  <div class="py1"></div>
                  <div class="clearfix">
                    <button class="col-12 action-button p2 gibson not-rounded flex justify-center items-center line-height-1"  @click="toggleFilter(status)">
                      <span class="h4 mb0">Sorter nu</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                </div>
              </b-collapse>
              <!-- mobile sorting collapse -->
              <b-collapse id="webCustomers">
                <div class="clearfix my3">
                  <div class="col-12 px0 flex justify-between items-center">
                    <p class="h4 darkblue gibson line-height-3">
                      Tilpas rækkefølgen
                    </p>
                    <button v-b-toggle.webCustomers class="white-button border-none not-rounded gibson">
                      <span>
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="py1"></div>
                   <b-form-group :value.sync="statusDate" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group >
                  <b-form-radio class="line-height-2 mb2" id="sortByDate" v-model="statusDate" :aria-describedby="ariaDescribedby" name="sortByDate" value="1" >
                    <span class="ml1 h5 regular relative m0">Sorter efter mødedato</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio class="line-height-2 mb2" id="sortByStatus" v-model="statusDate" :aria-describedby="ariaDescribedby" name="sortByStatus" value="2" >
                    <span class="ml1 h5 regular relative m0">Sorter efter status</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio class="line-height-2 mb2" id="offerSent" v-model="statusDate" :aria-describedby="ariaDescribedby" name="offerSent" value="3" >
                    <span class="ml1 h5 regular relative m0">Sorter efter sendt tilbud dato</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio class="line-height-2 mb2" id="followUp" v-model="statusDate" :aria-describedby="ariaDescribedby" name="followUp" value="4" >
                    <span class="ml1 h5 regular relative m0">Sorter efter opfølgningsdato</span>
                  </b-form-radio>
                   </b-form-radio-group>
                        </b-form-group>
                  <div class="py1"></div>
                  <div class="clearfix">
                    <button class="col-12 action-button p2 gibson not-rounded line-height-1" @click="toggleSort(statusDate)">
                      <span class="h4 mb0">Sorter nu</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                </div>
              </b-collapse>
              <div class="flex flex-column col-12 p0 m0 my2" v-if="browserName !== 'safari'">
                <p class="col-12 h5 semi-bold darkblue center p0">Oversigt over dine kunder om åretss</p>
                <div class="flex justify-start" style="overflow: auto; white-space: nowrap;">
                <button @click="filteryear(item)" :id="'yearfilter-' + item" class="primary-button-green pointer regular h5 white p2 mr1" style="width: 100%" v-for="(item,index) in allyear" :key="index">{{item}}
                </button>
                </div>
              </div>
            </div>
            <!-- large desktop header and search setup -->
            <div class="clearfix" v-if="!showMobile">
              <div class="col-12 p0 m0">
                <div class="clearfix">
                  <div class="col-12 px0">
                    <p class="h4 semi-bold line-height-2 my2">Dine kunder</p>
                    <p class="h5 regular darkblue gibson line-height-golden mb3 col-12 px0">
                      Dit samlede overblik over alle dine kunder - både fra Markedspladsen, din profil-side og Mester til Mester.<br><br>
                      Se historik, information og send tilbud til kunden med det samme herfra - hurtigt og enkelt.
                    </p>
                  </div>
                </div>
                <!-- largedesktop search input -->
                <div class="clearfix">
                  <div class="col-12 px0">
                    <div class="flex justify-start items-center py1 border muted-border mediumgrey shadow mb2">
                      <div class="flex-none px2">
                        <svg class="relative" style="top:3px;" width="18" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path class="st0" d="M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"/></svg>
                      </div>
                      <input class="searchBox gibson h4 darkblue regular mb0 p2 pl0" type="search" name="search" v-model="search" placeholder="Søg efter" style="background:transparent;">
                      <!-- <input type="submit" value="Search" class="searchButton"> -->
                    </div>
                  </div>
                  <!-- large desktop filter -->
                  <div class="col-12 px0 flex justify-start items-center mt3 mb2">
                    <div class="col-6 pr1 pl0">
                      <button v-b-toggle.webCustomers class="col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                        <span class="h5 mb0">Sortér</span>
                        <span class="relative ml2" style="top:4px;">
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                      </button>
                    </div>
                    <div class="col-6 px0">
                      <button v-b-toggle.m2m class="col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                        <span class="h5 mb0 mr2">Filter</span>
                        <span class="when-closed">
                          <span class="relative" style="top:3px;">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                          </span>
                        </span>
                        <span class="flex-none when-opened">
                          <span class="relative" style="top:3px;">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                          </span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <b-collapse id="m2m" class="col-6 right">
                <div class=" my3">
                  <div class="col-9 px0 flex justify-between items-center">
                    <p class="h5 darkblue gibson line-height-3">
                      Vælg
                    </p>
                    <button v-b-toggle.m2m class="white-button border-none not-rounded gibson">
                      <span>
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="py1"></div>
                  <!-- <b-form-checkbox id="sortByDate" v-model="status" name="sortByDate" value="accepted" unchecked-value="not_accepted">
                    <span class="ml1 h6 regular relative" style="top:-3px;">Mester-til-Mester</span>
                  </b-form-checkbox> -->
                <div class="col-12 px0 flex justify-start items-center my2">
                  <div class="col-6 px0">
                      <b-form-checkbox id="sortByStatusxxl1" v-model="status" name="sortByStatusxxl1" value="10" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">Mester til Mester</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox id="sortByHaveWorkxxl1" v-model="status" name="sortByHaveWorkxxl1" value="9" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">private</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox id="sortByNeedeWorkxxl1" v-model="status" name="sortByNeedeWorkxxl1" value="8" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">Med Tilbud</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox id="sortByNeedeWorkxxl2" v-model="status" name="sortByNeedeWorkxxl2" value="7" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">Uden Tilbud</span>
                      </b-form-checkbox>
                      <b-form-checkbox id="sortByquickofferl2" v-model="status" name="sortByquickofferl2" value="100" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">Kan ikke afgive tilbud</span>
                      </b-form-checkbox>
                      <b-form-checkbox id="ikkerelevant" v-model="status" name="ikkerelevant" value="12" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">ikke relevant</span>
                      </b-form-checkbox>
                  </div>
                  <div class="col-6 px0">
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByStatusxxl2" v-model="status" name="sortByStatusxxl2" value="0" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">Ny opgave</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByHaveWorkxxl2" v-model="status" name="sortByHaveWorkxxl2" value="1" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">I dialog</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByNeedeWorkxxl3" v-model="status" name="sortByNeedeWorkxxl3" value="2" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">Tilbud er sendt</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByNeedeWorkxxl4" v-model="status" name="sortByNeedeWorkxxl4" value="3" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">Vandt opgaven</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByNeedeWorkxxl5" v-model="status" name="sortByNeedeWorkxxl5" value="4" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">Opgaven er udført</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByNeedeWorkxxl6" v-model="status" name="sortByNeedeWorkxxl6" value="5" >
                      <span class="ml0 h6 regular relative" style="top:-3px;">Vandt ikke opgaven</span>
                    </b-form-checkbox>
                  </div>
                </div>
                  <div class="py1"></div>
                  <div class="clearfix">
                    <button class="col-6 action-button p2 gibson not-rounded flex justify-center items-center line-height-1" @click="toggleFilter(status)">
                      <span class="h4 mb0">Sorter nu</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                </div>
              </b-collapse>
              <b-collapse id="webCustomers" class="col-6">
                <div class="clearfix my3">
                  <div class="col-9 px0 flex justify-between items-center">
                    <p class="h5 darkblue gibson line-height-3">
                      Tilpas rækkefølgen
                    </p>
                    <button v-b-toggle.webCustomers class="white-button border-none not-rounded gibson">
                      <span>
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="pb3"></div>
                    <b-form-group :value.sync="statusDate" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group >
                  <b-form-radio id="sortByDatexxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="sortByDatexxl" value="1" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter mødedato</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="sortByStatusxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="sortByStatusxxl" value="2" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter status</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="offerSentxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="offerSentxxl" value="3" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter sendt tilbud dato</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="followUpxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="followUpxxl" value="4" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter opfølgningsdato</span>
                  </b-form-radio>
                     </b-form-radio-group>
                        </b-form-group>
                  <div class="pb5"></div>
                  <div class="clearfix">
                    <button class="col-6 action-button p2 gibson not-rounded" @click="toggleSort(statusDate)" >
                      <span class="h4 mb0">Sorter nu</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                </div>
              </b-collapse>
              <div class="flex col-12 p0 m0 my2" v-if="browserName !== 'safari'">
                <p class="h5 semi-bold darkblue p0 pr2">Oversigt over dine kunder om året</p>
                <div class="flex flex-wrap">
                <!-- <button @click="filteryear(item)" :id="'yearfilter-' + item" class="primary-button-green pointer regular h5 white p2 mr1" style="width:120px" v-for="(item,index) in allyear" :key="index">{{item}}
                </button> -->
                  <template>
                    <el-select v-model="activeyear" @change="filteryear(activeyear)" :id="'yearfilter-' + activeyear" placeholder="Select">
                      <el-option
                        v-for="(item,index) in allyear"
                        :key="index"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="flex justify-start p0 mb1" v-if="totalitems > 0">
      <el-pagination class="m0 p0" background layout="prev, pager, next" :page-size="perPage" @current-change="paginationChanged" :total="totalitems">
      </el-pagination>
    </div>
    <!-- loader -->
    <div class="clearfix" v-if="loading">
      <div class="col-12" >
        <div class="loader"></div>
      </div>
    </div>
    <div v-else>
      <div class=" flex flex-wrap justify-start" style="gap:1.5em;">
        <!-- eslint-disable -->
        <!-- bitrix customer -->
        <div class="flex items-stretch relative " v-for="(itemb,index) in SearchItembitrix" :key="itemb.ID" style="width:350px;" v-if="itemb.PROJECT_ID > 6000 && ((itemb.CONTRACT_TYPE === 'Fagentreprise' && itemb.PARENT_PROJECT.ID !== null) || (itemb.CONTRACT_TYPE === 'Hovedentreprise' && itemb.JOBS_LIST && itemb.JOBS_LIST.length > 0)) ">
        <div class="col-12 border muted-border p2 shadow">
            <!-- date and time -->
            <div class="clearfix mb1">
              <div class="col-12 p0 darkblue flex flex-column justify-start items-start mb1">
                <div class="flex flex-row col-12 p0 ">
                    <div class="col-6 mr-auto p0">
                      <svg fill="currentColor" width="48" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0" />
                        <path
                          d="m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0" />
                        <path d="m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0" />
                        <path
                          d="m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0" />
                        <path
                          d="m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0" />
                      </svg>
                    </div>
                    <div class="col-6 p0 flex items-center">
                      <!-- status select -->
                      <el-select v-model="valuestatus[index]" @change="updateJobsStatus(itemb.ID, index)" placeholder="Vælg"
                        class=" col-12 px0 white-background border-none darkblue semi-bold not-rounded">
                        <el-option v-for="items in itemb.STATUS" :key="items.ID" :label="items.TITLE_DK" :value="items.ID">
                        </el-option>
                      </el-select>
                    </div>
                </div>
              </div>
            </div>
            <!-- customer name -->
            <div class="col-12 p0">
              <div class="clearfix">
                <div class="darkblue mb1 flex col-12 p0 pointer">
                  <div class="col-11 m0 p0 flex flex-column">
                    <p class="h5 darkblue semi-bold m0 line-height-golden">
                      {{itemb.CUSTOMER_NAME}}
                    </p>
                    <div class="darkblue semi-bold flex p0 m0 mt1" v-if="itemb.PROJECT_ADDRESS.length > 0">
                      <span class="pr1 m0"><i class="el-icon-location-information primarycolor h6"></i></span>
                      <span class="font13 darkblue no-underline regular" style="max-lines:2;" target="_blank" v-if="itemb.CONTACT_FAKE_PHONE !== null && itemb.CONTACT_FAKE_PHONE !== '' && itemb.CALL_DATE === null">
                        {{(itemb.PROJECT_ZIP ? itemb.PROJECT_ZIP : '')}} {{' ' + (itemb.PROJECT_CITY ? itemb.PROJECT_CITY : '')}}
                      </span>
                      <a class="font13 darkblue no-underline regular" style="max-lines:2;" target="_blank" v-else
                      :href="'https://www.google.com/maps/search/?api=1&query=' + itemb.PROJECT_ADDRESS">
                        {{itemb.PROJECT_ADDRESS}}
                      </a>
                    </div>
                    <div class="flex flex-column">
                      <a type="button" :href="'mailto:'" class="font13 regular no-underline mb1" v-if="itemb.CONTACT_FAKE_PHONE !== null && itemb.CONTACT_FAKE_PHONE !== '' && itemb.CALL_DATE === null">
                        <span class="font13 primarycolor flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" height="10" viewBox="0 0 24.337 15.571">
                            <path id="Beskeder" d="M-919.1-96.429a1.854,1.854,0,0,1-1.9-1.8V-110.2a1.854,1.854,0,0,1,1.9-1.8h2.519a.463.463,0,0,1,.476.45.463.463,0,0,1-.476.45H-919.1c-.025,0-.049,0-.073,0l8.9,8.429a2.114,2.114,0,0,0,2.871,0l6.626-6.272h-5.25a.463.463,0,0,1-.476-.45.464.464,0,0,1,.476-.451h6.2l1.328-1.257c-.024,0-.049,0-.073,0h-13.781a.463.463,0,0,1-.475-.45.463.463,0,0,1,.475-.45h13.781a1.854,1.854,0,0,1,1.9,1.8v11.972a1.854,1.854,0,0,1-1.9,1.8Zm-.245-.931a.988.988,0,0,0,.245.032h20.534a.98.98,0,0,0,.245-.032l-6.668-6.314-1.736,1.643a3.059,3.059,0,0,1-2.107.825,3.062,3.062,0,0,1-2.109-.825l-1.735-1.643Zm15.029-6.95L-897.647-98a.839.839,0,0,0,.033-.232V-110.2a.86.86,0,0,0-.086-.372ZM-920.05-110.2v11.972a.846.846,0,0,0,.033.232l6.669-6.313-6.616-6.263A.847.847,0,0,0-920.05-110.2Zm12.026,2.039a.565.565,0,0,1-.565-.564.564.564,0,0,1,.565-.564h.008a.564.564,0,0,1,.565.564.565.565,0,0,1-.565.564Zm-6.4-2.71a.564.564,0,0,1-.564-.564.564.564,0,0,1,.564-.563h.007a.563.563,0,0,1,.564.563.564.564,0,0,1-.564.564Z" transform="translate(921 112)" fill="#19a3c0"/>
                          </svg>
                          <span class="pl1 font13 darkblue regular">{{hideemail(itemb.CUSTOMER_EMAIL)}}</span>
                        </span>
                      </a>
                      <a type="button" :href="'mailto:'+ itemb.CUSTOMER_EMAIL" class="font13 regular no-underline mb1" v-else>
                        <span class="font13 primarycolor flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" height="10" viewBox="0 0 24.337 15.571">
                            <path id="Beskeder" d="M-919.1-96.429a1.854,1.854,0,0,1-1.9-1.8V-110.2a1.854,1.854,0,0,1,1.9-1.8h2.519a.463.463,0,0,1,.476.45.463.463,0,0,1-.476.45H-919.1c-.025,0-.049,0-.073,0l8.9,8.429a2.114,2.114,0,0,0,2.871,0l6.626-6.272h-5.25a.463.463,0,0,1-.476-.45.464.464,0,0,1,.476-.451h6.2l1.328-1.257c-.024,0-.049,0-.073,0h-13.781a.463.463,0,0,1-.475-.45.463.463,0,0,1,.475-.45h13.781a1.854,1.854,0,0,1,1.9,1.8v11.972a1.854,1.854,0,0,1-1.9,1.8Zm-.245-.931a.988.988,0,0,0,.245.032h20.534a.98.98,0,0,0,.245-.032l-6.668-6.314-1.736,1.643a3.059,3.059,0,0,1-2.107.825,3.062,3.062,0,0,1-2.109-.825l-1.735-1.643Zm15.029-6.95L-897.647-98a.839.839,0,0,0,.033-.232V-110.2a.86.86,0,0,0-.086-.372ZM-920.05-110.2v11.972a.846.846,0,0,0,.033.232l6.669-6.313-6.616-6.263A.847.847,0,0,0-920.05-110.2Zm12.026,2.039a.565.565,0,0,1-.565-.564.564.564,0,0,1,.565-.564h.008a.564.564,0,0,1,.565.564.565.565,0,0,1-.565.564Zm-6.4-2.71a.564.564,0,0,1-.564-.564.564.564,0,0,1,.564-.563h.007a.563.563,0,0,1,.564.563.564.564,0,0,1-.564.564Z" transform="translate(921 112)" fill="#19a3c0"/>
                          </svg>
                          <span class="pl1 font13 darkblue regular">{{itemb.CUSTOMER_EMAIL}}</span>
                        </span>
                      </a>
                      <a type="button" :href="'tel:' + itemb.CONTACT_FAKE_PHONE" class="font13 regular no-underline" v-if="itemb.CONTACT_FAKE_PHONE !== null && itemb.CONTACT_FAKE_PHONE !== '' && itemb.CALL_DATE === null">
                        <span class="font13 primarycolor">
                          <svg fill="currentColor" class="primarycolor-fill" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path
                              d="M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z" />
                            <path
                              d="M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z" />
                            <path
                              d="M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z" />
                            <path
                              d="M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z" />
                          </svg>
                        </span>
                        <span class="pl1 font13 darkblue regular">+45 {{itemb.CONTACT_FAKE_PHONE}}</span>
                      </a>
                      <a type="button" :href="'tel:' + itemb.CUSTOMER_MOBILE" class="font13 regular no-underline" v-else>
                        <span class="font13 primarycolor">
                          <svg fill="currentColor" class="primarycolor-fill" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z" />
                            <path d="M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z" />
                            <path d="M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z" />
                            <path d="M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z" />
                          </svg>
                        </span>
                        <span class="pl1 font13 darkblue regular">+45 {{itemb.CUSTOMER_MOBILE}}</span>
                      </a>
                    </div>
                    <a type="button" class="primarycolor h6 regular pointer mt1" @click="projectdesctionopen(itemb.PROJECT_DESCRIPTION, itemb.PROJECT_NAME)">
                      <svg xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 41.182 47.344">
                        <g id="description" transform="translate(0)">
                          <path id="Path_395" data-name="Path 395" d="M72.982,6.426,67.29.734A2.491,2.491,0,0,0,65.518,0h-18.4a2.509,2.509,0,0,0-2.507,2.507v5.52H35.041a2.509,2.509,0,0,0-2.507,2.507V26.606a.948.948,0,0,0,1.894,0V10.533a.614.614,0,0,1,.613-.613H53.034v4.233a2.51,2.51,0,0,0,2.507,2.507h4.2V44.837a.614.614,0,0,1-.613.613H35.041a.614.614,0,0,1-.613-.613V34.359a.948.948,0,0,0-1.894,0V44.837a2.509,2.509,0,0,0,2.507,2.507H59.128a2.509,2.509,0,0,0,2.507-2.507v-5.52H71.21a2.509,2.509,0,0,0,2.507-2.507V8.2a2.491,2.491,0,0,0-.734-1.773Zm-2.365.314H67.623a.614.614,0,0,1-.613-.613V3.132Zm-15.69,7.414V11.159l3.608,3.608H55.541A.614.614,0,0,1,54.928,14.153ZM71.21,37.423H61.634v-21.2a2.49,2.49,0,0,0-.734-1.773L55.208,8.761a2.491,2.491,0,0,0-1.773-.734H46.51V2.507a.614.614,0,0,1,.613-.613H65.116V6.127a2.51,2.51,0,0,0,2.507,2.507h4.2V36.81a.614.614,0,0,1-.613.613Z" transform="translate(-32.534 0)" fill="#19a3c0"/>
                          <path id="Path_396" data-name="Path 396" d="M90.687,195.221h6.54a.948.948,0,0,0,0-1.894h-6.54a.948.948,0,0,0,0,1.894Z" transform="translate(-84.354 -175.02)" fill="#19a3c0"/>
                          <path id="Path_397" data-name="Path 397" d="M90.687,237.113h16.331a.948.948,0,0,0,0-1.894H90.687A.948.948,0,0,0,90.687,237.113Z" transform="translate(-84.354 -212.946)" fill="#19a3c0"/>
                          <path id="Path_398" data-name="Path 398" d="M90.687,281.611h16.331a.948.948,0,0,0,0-1.894H90.687A.948.948,0,0,0,90.687,281.611Z" transform="translate(-84.354 -253.23)" fill="#19a3c0"/>
                          <path id="Path_399" data-name="Path 399" d="M90.687,324.8h16.331a.948.948,0,0,0,0-1.894H90.687A.948.948,0,0,0,90.687,324.8Z" transform="translate(-84.354 -292.334)" fill="#19a3c0"/>
                          <path id="Path_400" data-name="Path 400" d="M90.687,368h16.331a.948.948,0,0,0,0-1.894H90.687A.948.948,0,0,0,90.687,368Z" transform="translate(-84.354 -331.438)" fill="#19a3c0"/>
                          <path id="Path_401" data-name="Path 401" d="M33.558,313.686a.947.947,0,1,0-.653-1.632.957.957,0,0,0,.653,1.632Z" transform="translate(-32.611 -282.275)" fill="#19a3c0"/>
                        </g>
                      </svg>
                      <span class="pl1 font13 darkblue regular"> Se beskrivels</span>
                    </a>
                  </div>
                  <!-- <div class="col-3 p0 m0 flex flex-column items-end">
                    <image-rating :rating="5" src='/static/svg/single-house.svg' :max-rating="5" :increment="0.5"
                      :item-size="15" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
                    <p class="font14">{{'5'}} out of 5</p>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-12 m0 p0 flex items-center relative" style="height:53px;">
              <el-tooltip content="" id="projectTitle" placement="top" effect="light" v-if="itemb.PROJECT_NAME.length  > 109">
                <template slot="content">
                  <div class="">
                    {{itemb.PROJECT_NAME}}
                  </div>
                </template>
                <p class="h6 semi-bold darkblue">{{itemb.PROJECT_NAME | truncate(110, '...')}}</p>
              </el-tooltip>
              <p class="h6 semi-bold darkblue" v-else>{{itemb.PROJECT_NAME}}</p>
            </div>
            <div class="col-12 m0 p0 mb2 pb2 darkblue flex border border-top-0 border-left-0 border-right-0 muted-border">
              <button class="px2 px1 col-5 outlined-standard-button flex items-center rounded" @click="opennotes(itemb.NOTES, itemb.ID)">
                <span class="pr1">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18.582" height="16.082" viewBox="0 0 34.021 34.02">
                    <defs>
                      <clipPath id="clip-path">
                        <rect id="Rectangle_1452" data-name="Rectangle 1452" width="34.021" height="34.02" transform="translate(0 0)" fill="#134553"/>
                      </clipPath>
                    </defs>
                    <g id="note" clip-path="url(#clip-path)">
                      <path id="Path_4217" data-name="Path 4217" d="M12.359,0h.8a1.506,1.506,0,0,0,.183.066,2.711,2.711,0,0,1,1.7,1.124.482.482,0,0,0,.465.227c.7-.009,1.395-.009,2.092,0a2.166,2.166,0,0,1,2.044,1.231A.474.474,0,0,0,20,2.832c1.052.015,2.1,0,3.155.011a3.081,3.081,0,0,1,.724.064A2.1,2.1,0,0,1,25.512,5.05c.007,1.627,0,3.255,0,4.882v.33l.1.038c.734-.752,1.44-1.536,2.21-2.25a3.708,3.708,0,0,1,5.021,5.457q-3.526,3.543-7.072,7.066a.808.808,0,0,0-.269.632q.014,5.281,0,10.561a2.124,2.124,0,0,1-2.219,2.251q-10.545.008-21.09-.008a2.759,2.759,0,0,1-1.05-.25A2.161,2.161,0,0,1,0,32.226V4.652C.542,3.194,1.051,2.841,2.609,2.841c.962,0,1.923-.006,2.885,0a.4.4,0,0,0,.428-.261A1.941,1.941,0,0,1,7.561,1.451a16.44,16.44,0,0,1,1.888-.029A1.273,1.273,0,0,0,10.74.889,2.626,2.626,0,0,1,12.359,0M24.1,22.272c-.16.152-.248.234-.333.319-1.315,1.315-2.623,2.638-3.952,3.939a1.808,1.808,0,0,1-.759.434c-1.216.33-2.44.631-3.665.925a12.71,12.71,0,0,1-2.168.447c-1.247.074-2.5.021-3.752.02-.62,0-.965-.259-.962-.717s.344-.709.97-.71c1.041,0,2.082-.008,3.122.006.247,0,.34-.076.4-.315.264-1.119.55-2.232.828-3.348.047-.187.091-.374.144-.6h-.415c-1.406,0-2.812,0-4.218,0-.507,0-.834-.292-.828-.71s.332-.692.844-.7c.077,0,.155,0,.233,0,1.572,0,3.144.006,4.717-.009a.765.765,0,0,0,.482-.2c1.278-1.258,2.543-2.53,3.811-3.8.064-.064.118-.138.21-.245H9.518c-.1,0-.2,0-.3,0a.7.7,0,1,1,.02-1.4c.088-.006.177,0,.266,0H19.569a1.331,1.331,0,0,1,.4.022.348.348,0,0,0,.4-.128c1.179-1.186,2.366-2.362,3.538-3.555a.77.77,0,0,0,.193-.487c.015-1.417.009-2.834.009-4.251,0-.7.007-1.4,0-2.093a.753.753,0,0,0-.862-.852c-1.041,0-2.081,0-3.122,0-.084,0-.168.015-.269.025,0,.234.015.446,0,.654a.715.715,0,0,1-.775.731c-.188.007-.376,0-.565,0q-5.962,0-11.925,0c-.651,0-.9-.255-.913-.9,0-.162,0-.324,0-.513H2.409c-.759,0-1,.234-1,.986q0,13.187,0,26.373c0,.755.239.994.993.994H23.1c.772,0,1-.235,1-1.017q0-4.451,0-8.9v-.416m5.269-7.4-3.159-3.157-9.9,9.9a5.961,5.961,0,0,1,3.166,3.151l9.888-9.889M7.133,4.235H18.422c0-.159,0-.3,0-.441,0-.729-.224-.952-.949-.954-.841,0-1.682-.008-2.524,0a.884.884,0,0,1-.912-.57,1.391,1.391,0,0,0-2.559,0,.885.885,0,0,1-.91.573c-.752-.011-1.506.024-2.258-.009-1.225-.055-1.268.4-1.2,1.353,0,.009.01.018.027.048m23.381,9.629c.542-.567,1.139-1.117,1.646-1.74a2.276,2.276,0,0,0-3.15-3.2c-.636.505-1.19,1.114-1.763,1.659l3.267,3.279M18.325,25.694a4.6,4.6,0,0,0-2.914-2.909l-.969,3.882,3.883-.973" transform="translate(0 -0.001)" fill="#134553"/>
                      <path id="Path_4218" data-name="Path 4218" d="M109.374,119.175q3.021,0,6.042,0a2.283,2.283,0,0,1,.493.046.688.688,0,0,1,0,1.331,1.9,1.9,0,0,1-.427.046q-6.125,0-12.25,0c-.622,0-.965-.256-.965-.713s.343-.713.965-.713h6.142" transform="translate(-93.758 -109.258)" fill="#134553"/>
                      <path id="Path_4219" data-name="Path 4219" d="M34.188,104.336a2.12,2.12,0,1,1,2.117,2.139,2.126,2.126,0,0,1-2.117-2.139m2.812.03a.7.7,0,0,0-.673-.714.717.717,0,0,0-.726.7.724.724,0,0,0,.7.7.7.7,0,0,0,.7-.688" transform="translate(-31.343 -93.72)" fill="#134553"/>
                      <path id="Path_4220" data-name="Path 4220" d="M34.187,308.737a2.12,2.12,0,1,1,2.117,2.14,2.126,2.126,0,0,1-2.117-2.14m2.812.018a.7.7,0,0,0-.686-.7.7.7,0,1,0,0,1.4.7.7,0,0,0,.69-.7" transform="translate(-31.342 -281.112)" fill="#134553"/>
                      <path id="Path_4221" data-name="Path 4221" d="M36.313,174.585a2.121,2.121,0,0,1-.021-4.242,2.121,2.121,0,1,1,.021,4.242m0-2.812a.709.709,0,0,0-.715.676.727.727,0,0,0,.708.724.71.71,0,0,0,.692-.7.69.69,0,0,0-.685-.7" transform="translate(-31.342 -156.168)" fill="#134553"/>
                      <path id="Path_4222" data-name="Path 4222" d="M34.179,240.689a2.121,2.121,0,0,1,4.241.014,2.121,2.121,0,1,1-4.241-.014m2.814,0a.711.711,0,0,0-.7-.7.73.73,0,0,0-.706.694.709.709,0,0,0,.72.705.69.69,0,0,0,.682-.7" transform="translate(-31.335 -218.725)" fill="#134553"/>
                    </g>
                  </svg>
                </span>
                <p class="regular small h6 p0 m0">DINE NOTATER</p>
              </button>
              <button class="px2 py1 ml-auto col-6 primary-button flex items-center rounded justify-center" @click="seeTenderFile(itemb)">
                <span class="pr1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18.582" height="16.082" viewBox="0 0 18.582 16.082">
                    <path id="tender_folder_ic" d="M3.324,15.531a.351.351,0,1,1,.351.351A.351.351,0,0,1,3.324,15.531Zm12.78.245c-4.205,0-6.492,0-10.7,0-.146,0-.279-.02-.344-.172a.259.259,0,0,1,.195-.356,1.211,1.211,0,0,1,.214-.01l10.518.006c.366,0,.426-.06.426-.429V4.676a.639.639,0,0,0-.1-.427.519.519,0,0,0-.448-.177H13.711c-1.964,0-3.926-.008-5.894,0A1.724,1.724,0,0,1,6.21,3.214a1.335,1.335,0,0,0-1.283-.683q-1.744.034-3.486,0C.827,2.519.5,2.741.5,3.462q.006,5.56.006,11.12c0,.473.172.643.651.643h.9c.216,0,.331.1.331.269s-.112.268-.33.268q-.5,0-.988,0c-.556,0-1.071-.238-1.071-.8L.029,2.956a1.106,1.106,0,0,1,1.219-.95c.123,0,.147-.046.147-.157a3.522,3.522,0,0,1,.026-.77A1.335,1.335,0,0,1,2.731.01Q4.666-.01,6.6.01A1.617,1.617,0,0,1,7.97.766c.058.084.112.169.17.253a1.142,1.142,0,0,0,.988.519h2.208a.874.874,0,0,1,.162,0,.257.257,0,0,1,.233.273.253.253,0,0,1-.248.259,1.19,1.19,0,0,1-.126,0c-.958,0-1.214-.006-2.173,0A1.693,1.693,0,0,1,7.649,1.25,1.342,1.342,0,0,0,6.882.589a1.624,1.624,0,0,0-.426-.05H2.862a.828.828,0,0,0-.929.928c0,.126.012.245,0,.377S1.975,2,2.1,2c.426,0,.854,0,1.282,0,.555,0,1.11,0,1.666,0a1.676,1.676,0,0,1,1.56.843,1.376,1.376,0,0,0,1.313.7c2.646-.014,5.295-.006,7.942-.006a1.008,1.008,0,0,1,1.063.732,1.547,1.547,0,0,1,.038.427q0,4.179,0,8.358c0,.159.038.209.2.193.13-.012.264,0,.4,0,.2,0,.288-.1.294-.3V2.677c0-.442-.159-.6-.607-.6H14.69a1.247,1.247,0,0,1-.179,0,.266.266,0,0,1-.027-.524.71.71,0,0,1,.179-.009h2.473c.739,0,1.246.11,1.246.822v10.8c0,.3-.188.618-1.013.619-.43,0-.414,0-.414.415,0,.243,0,.49,0,.735a.8.8,0,0,1-.8.845ZM12.67,2.154a.408.408,0,0,1-.351-.357.408.408,0,0,1,.351-.357h.681a.388.388,0,0,1,.33.357.388.388,0,0,1-.33.357Z" transform="translate(0.1 0.1)" fill="#fff" stroke="#fff" stroke-width="0.2"/>
                  </svg>
                </span>
                <p class="regular small h6 p0 m0">UDBUDSMATERIALE</p>
              </button>
            </div>
            <div class="col-12 mb1 p0" v-if="itemb.OFFER_STATUS === 'accepted'">
              <button @click="showprojectdash(itemb)"
                class="kundebutton col-12 outlined-primary-button p1 flex justify-center items-center gibson line-height-1 rounded">
                <span class="relative col-4 flex justify-end pr2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 13.366 13.228">
                    <path id="Styr_Projekt" data-name="Projekt admin"
                      d="M9.651,13.131a1.646,1.646,0,0,1-.557.1H1.654A1.656,1.656,0,0,1,0,11.574V1.655A1.656,1.656,0,0,1,1.654,0H6.633a.417.417,0,0,1,.289.135l3.706,3.706.019.02a.414.414,0,0,1,.1.273V8.649a4,4,0,0,1,2.574,2.089.414.414,0,0,1,0,.371c-.043.086-1.081,2.119-2.97,2.119A2.584,2.584,0,0,1,9.651,13.131ZM8.23,10.922A2.813,2.813,0,0,0,10.352,12.4a2.8,2.8,0,0,0,2.123-1.476,2.812,2.812,0,0,0-2.123-1.478A2.8,2.8,0,0,0,8.23,10.922ZM.828,1.655v9.92a.827.827,0,0,0,.826.826H8.381a4.868,4.868,0,0,1-1-1.291.418.418,0,0,1,0-.371,3.99,3.99,0,0,1,2.6-2.093l-.063.01V4.548H6.615A.415.415,0,0,1,6.2,4.134V.828H1.654A.828.828,0,0,0,.828,1.655ZM10,8.643h0Zm.454-.022h0Zm-.022,0h0Zm-.023,0h0Zm-.023,0h0Zm-.061,0h0Zm.032,0h0ZM7.029,3.72H9.335L7.029,1.413Zm2.2,7.2a1.123,1.123,0,1,1,1.123,1.123A1.124,1.124,0,0,1,9.23,10.924Zm.828,0a.3.3,0,1,0,.295-.3A.3.3,0,0,0,10.058,10.924ZM2.9,9.8a.414.414,0,1,1,0-.828H5.657a.414.414,0,1,1,0,.828Zm0-2.069a.414.414,0,1,1,0-.828H7.727a.414.414,0,0,1,0,.828Zm0-2.559a.414.414,0,1,1,0-.828h1.24a.414.414,0,1,1,0,.828Z"
                      fill="#19a3c0" />
                  </svg>
                </span>
                <span class="h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start">Projektadministration</span>
              </button>
            </div>
            <div class="col-12 mb1 p0" v-else-if="itemb.OFFER_STATUS === null">
              <button id="createoffer" @click="showMeetingTilbudbitrix(itemb, 'bitrixCustomersBookingwizard')" class="kundebutton dark-button col-12 outlined-action-button p1 flex justify-center rounded items-center gibson line-height-1">
                <!-- <span class="relative col-4 flex justify-end pr2 ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 21.805 13.414">
                    <path id="opret_tilbud" data-name="opret tilbud"
                      d="M.476,13.414A.477.477,0,0,1,0,12.938V3.99a.477.477,0,0,1,.476-.476H1.49L2.337.352A.476.476,0,0,1,2.778,0H2.8a.507.507,0,0,1,.12.015L15.261,3.322a.475.475,0,0,1,.348.395l.317,2.233a2.79,2.79,0,0,1,2.308,1.676,2.819,2.819,0,0,1,.134.385A5.351,5.351,0,0,1,19,7.988h.411a2.374,2.374,0,0,1,1.692.7,2.4,2.4,0,0,1,.7,1.692.476.476,0,1,1-.951,0A1.443,1.443,0,0,0,19.413,8.94c-.15,0-.289,0-.423.007-.113,0-.221.006-.319.006-.078,0-.15,0-.216-.006a2.8,2.8,0,0,1-3.749,2.41l-1.039,1.818a.476.476,0,0,1-.413.24Zm.475-.952H12.978l.9-1.581a2.809,2.809,0,0,1-.875-1.3A1.434,1.434,0,1,1,14,9.2a1.723,1.723,0,0,0,.421.737l.839-1.468-2.285-4H.951Zm14.717-2a1.73,1.73,0,0,0,.414-3.409l.179,1.259a.483.483,0,0,1-.037.388l-.977,1.709A1.722,1.722,0,0,0,15.668,10.462ZM12.55,8.145a.476.476,0,0,0,.328.457,2.8,2.8,0,0,1,.207-.935l-.055,0A.476.476,0,0,0,12.55,8.145Zm2.429-2.1-.268-1.89L13.752,3.9ZM12.3,3.514,3.133,1.058,2.474,3.514Z"
                      fill="#4dcf55" />
                  </svg>
                </span> -->
                <span class="h6 mb0 line-height-1 semi-bold center">AFGIV TILBUD</span>
              </button>
            </div>
            <div class="col-12 mb1 p0 flex" v-else-if="itemb.OFFER_STATUS === 'pending'  || itemb.OFFER_STATUS === 'Failed' || itemb.OFFER_STATUS === 'failed'">
              <!-- <button @click="showtilbudhistory(itemb)" class="kundebutton dark-button col-12 outlined-action-button p1 flex justify-center items-center gibson line-height-1"> -->
              <button @click="getAcceptedOfferPrice(itemb.OFFER_ID, itemb.PROJECT_ID, itemb.CUSTOMER_ID, itemb.CONTRACT_TYPE, itemb.PROJECT_PARENT_ID, 0, itemb.JOBS_LIST)" class="kundebutton dark-button col-6 outlined-action-button p1 flex justify-center items-center gibson line-height-1 rounded">
                <span class="font14 mb0 line-height-1 semi-bold center">SE TILBUD</span>
              </button>
              <button @click="edittilbud(itemb)" class="rounded kundebutton dark-button col-6 outlined-action-button p1 flex justify-center items-center gibson line-height-1">
                <span class="font14 mb0 line-height-1 semi-bold center">REDIGER TILBUD</span>
              </button>
            </div>
            <div class="col-12 mb1 p0 flex">
                <button @click="seeMessages(itemb.CUSTOMER_ID, itemb.ID)" class="rounded kundebutton col-12 outlined-primary-button p1 flex justify-center items-center gibson line-height-1 rounded">
                <span class="h6 mb0 line-height-1 semi-bold center">Besked</span>
              </button>
            </div>
        </div>
        </div>
        <!-- kundematch customer -->
        <div class="flex items-stretch relative " v-for="item in SearchItem" :key="item.id" v-if="(item.id_appointment_status_support === '0' && lastpage === currentpage) || (item.id_appointment_status_support === '0' && SearchItembitrix.length < 1)" style="width:350px;">
          <div class="col-12 border muted-border p2 shadow">
            <!-- date and time -->
            <div class="clearfix mb2 mt2" v-if="item.henttilbud !== 1">
              <div class="col-12 gibson darkblue flex">
                <div class="pr2 mr-auto">
                  <svg fill="currentColor" width="48" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path d="m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"/><path d="m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"/><path d="m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"/><path d="m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"/><path d="m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"/></svg>
                </div>
                <div class="ml-auto flex flex-column items-end">
                  <p class="h5 semi-bold line-height-1 mb0" style="margin-bottom:5px;">
                    {{moment(item.appointment_date).locale('da').format('LL')}}
                  </p>
                  <p class="regular line-height-1 mb0">
                    kl. {{item.id_times}}
                  </p>
                </div>
              </div>
              <div  class="col-8 p0 m0 flex justify-end ml-auto">
                <b-form-select :disabled="disableStatusSelection" id="statusSelect2" v-model="item.tilbudstatus" :options="item.dataStatus" @change="changeStatus($event,item)" class="px0 darkblue semi-bold not-rounded" >
                </b-form-select>
                <button type="button" :id="'recommendInvitation-' + item.id_appointment" class="hide" v-confirm="{ ok: confirmRecommendInvitation('4', item, 'yes'), cancel: confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}">Recommend Invitation</button>
              </div>
            </div>
            <div class="clearfix mb1" v-else>
              <div class="col-12 p0 darkblue flex flex-column justify-start items-start mb1">
                <div class="flex flex-row col-12 p0">
                    <div class="col-4 mr-auto p0 flex flex-column m0">
                      <svg fill="currentColor" width="60" height="52" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0" />
                        <path
                          d="m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0" />
                        <path d="m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0" />
                        <path
                          d="m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0" />
                        <path
                          d="m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0" />
                      </svg>
                      <p class="small m0" style="font-size:9px;">{{moment(item.datereserve.split(' ')[0]).locale('da').format('LL')}}</p>
                    </div>
                    <div class="col-8 p0 flex items-center justify-center flex-column">
                      <!-- status select -->
                        <div class="m0 p0 small">
                          <span class="regular" v-if="item.newcontact != '0' || item.newcontact_pro != '0'">
                              <em>Direkte fra din profilside</em>
                          </span>
                          <span class="regular" v-else><em>Reserveret fra markedspladsen</em></span>
                        </div>
                        <input type="hidden" :id="'tilbudstatusval-' + item.id_appointment" :value="item.tilbudstatus" >
                        <div  class="col-12 p0 m0 flex justify-end">
                          <b-form-select :disabled="disableStatusSelection" id="statusSelect2" v-model="item.tilbudstatus" :options="item.dataStatus" @change="changeStatus($event,item)" class="px0 darkblue semi-bold not-rounded" >
                          </b-form-select>
                          <button type="button" :id="'recommendInvitation-' + item.id_appointment" class="hide" v-confirm="{ ok: confirmRecommendInvitation('4', item, 'yes'), cancel: confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}">Recommend Invitation</button>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <!-- customer name -->
            <div class="col-12 p0">
              <div class="clearfix">
                <div class="darkblue mb1 flex col-12 p0 pointer" @click="getReviewIdbycustomerId(itemb.CUSTOMER_ID)">
                  <div class="col-12 m0 p0 flex flex-column">
                    <p class="h5 darkblue semi-bold m0 line-height-golden">
                      {{item.firstname.replace('&oslash;', 'ø').replace('&aring;', 'å').replace('&aelig;;', 'æ')}} {{item.lastname.replace('&oslash;', 'ø').replace('&aring;', 'å').replace('&aelig;;', 'æ')}}
                    </p>
                    <!-- customer address -->
                    <div class="darkblue semi-bold flex p0 m0 mt1" v-if="item.mailingstreet && item.mailingzip && item.mailingcity !== '0'">
                      <span class="pr1 m0"><i class="el-icon-location-information primarycolor h6"></i></span>
                      <a class="font13 darkblue no-underline regular no-hover" style="max-lines:2;" target="_blank"
                        :href="'https://www.google.com/maps/search/?api=1&query=' + item.mailingstreet + ' ' + item.mailingzip + ' ' + item.mailingcity "  >
                        {{ (item.mailingstreet + ' ' + item.mailingzip + ' ' + item.mailingcity)| truncate(45, '...') }}
                      </a>
                    </div>
                    <div class="">
                      <a type="button"  :href="'tel:' + item.mobile" class="font13 regular no-hover" v-if="item.mobile != null">
                        <span class="font13 primarycolor">
                          <svg fill="currentColor" class="primarycolor-fill" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path
                              d="M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z" />
                            <path
                              d="M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z" />
                            <path
                              d="M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z" />
                            <path
                              d="M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z" />
                          </svg>
                        </span>
                        <span class="pl1 font13 darkblue regular">+45 {{item.mobile}}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- large desktop se mere collapse button -->
            <div class="col-12 gibson ">
              <p v-b-toggle="'optionsCollapse'+item.id_appointment" class="h6 primarycolor regular line-height-1 my2 flex justify-between items-center">
                <span>Se mere information om kunden</span>
                <span class="when-closed">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-down"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-6.172l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.243a1 1 0 0 1-1.414 0L5.05 9.707a1 1 0 0 1 1.414-1.414L10 11.828z' /></svg>
                  </span>
                </span>
                <span class="flex-none when-opened">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-up-f"><path d='M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
                  </span>
                </span>
              </p>
              <b-collapse :id="'optionsCollapse'+item.id_appointment">
                <div class="col-12 px0 gibson" v-if="item.henttilbud !== 1">
                  <!-- large desktop call customer -->
                  <div class="col-12 px0 flex flex-column">
                    <a :href="'mailto:' + item.email" class="h5 darkblue semi-bold line-height-3 flex col-12 justify-start items-center px2 no-hover">
                      <span class="mr2 relative" style="top:3px;">
                        <svg fill="currentColor" width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"/><path d="M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"/><path d="M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"/></svg>
                      </span>
                      <span class="h6 line-height-1 mb0">{{item.email}}</span>
                    </a>
                  </div>
                  <div class="py1"></div>
                  <div class="flex flex-column">
                    <button class="mb1 outlined-button border-none px1 py2 not-rounded flex justify-start items-center" @click="prisUrlOpen(item)" v-if="item.potentialnameurl !== ''">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M85.7 49c-20.2 0-36.7 16.5-36.7 36.7s16.5 36.7 36.7 36.7c20.2 0 36.7-16.5 36.7-36.7S105.9 49 85.7 49zM85.7 102c-9 0-16.3-7.3-16.3-16.3 0-9 7.3-16.3 16.3-16.3s16.3 7.3 16.3 16.3C102 94.7 94.7 102 85.7 102z"/><path d="M499.2 265.2L279.6 45.6c-6.5-6.5-14.8-10.8-23.9-12.2L50.5 0.6C36.5-1.7 22.8 2.8 12.8 12.8 2.8 22.8-1.7 36.5 0.6 50.5l32.8 205.2c1.5 9.1 5.7 17.4 12.2 23.9l219.6 219.6c8.2 8.2 19.2 12.8 30.8 12.8 11.6 0 22.6-4.5 30.8-12.8l172.4-172.4C516.2 309.8 516.2 282.2 499.2 265.2zM484.8 312.4L312.4 484.8c-9 9-23.8 9-32.8 0L60 265.2c-3.5-3.5-5.7-7.9-6.5-12.7L20.7 47.3c-1.2-7.4 1.2-14.7 6.5-20.1 4.4-4.4 10.2-6.8 16.3-6.8 1.2 0 2.5 0.1 3.8 0.3l205.2 32.8c4.9 0.8 9.3 3 12.7 6.5l219.6 219.6v0C493.9 288.7 493.9 303.4 484.8 312.4z"/><path d="M323.4 188.6c-4-4-10.4-4-14.4 0L188.6 309c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3L323.4 203C327.4 199.1 327.4 192.6 323.4 188.6z"/><path d="M364.2 229.4c-4-4-10.4-4-14.4 0l-3.1 3.1c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3l3.1-3.1C368.2 239.9 368.2 233.4 364.2 229.4z"/><path d="M337.7 255.9c-4-4-10.4-4-14.4 0l-93.8 93.8c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3l93.8-93.8C341.7 266.4 341.7 259.9 337.7 255.9z"/></svg>
                      </span>
                      <span class="h6 line-height-1 mb0" style="font-weight:600!important;">Prisoverslag</span>
                    </button>
                    <button class="mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center" @click="prisUrlOpenFile(item)" v-if="item.potentialnameurl !== '' && item.numoffile > 0">
                      <span class="mr2 relative" style="top:2px;">
                          <svg fill="currentColor" width="18" height="24" viewBox="-40 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m402 0h-280c-16.542969 0-30 13.457031-30 30v26h-62c-16.542969 0-30 13.457031-30 30v338.589844c.0078125.007812.015625.015625.0234375.019531.0039063 2.59375.9960935 5.144531 2.9062505 7.050781l77.40625 77.410156c1.914062 1.914063 4.472656 2.929688 7.074218 2.929688h.011719 222.578125c16.542969 0 30-13.457031 30-30v-26h62c16.542969 0 30-13.457031 30-30v-125c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v125c0 5.515625-4.484375 10-10 10h-62v-57.863281h29.539062c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-29.539062v-35.992188h29.539062c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10h-29.539062v-36.019531h29.539062c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-29.539062v-35.988281h29.539062c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-29.539062v-36.023438h29.539062c5.523438 0 10-4.476562 10-10 0-5.519531-4.476562-10-10-10h-29.539062v-48.113281c0-3.507812-.609375-6.871094-1.71875-10h73.71875v135c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-181c0-16.542969-13.457031-30-30-30zm-324.589844 477.859375-43.269531-43.269531h29.203125c7.753906 0 14.066406 6.3125 14.066406 14.066406zm242.589844 4.140625c0 5.515625-4.484375 10-10 10h-212.589844v-43.34375c0-18.785156-15.28125-34.066406-34.066406-34.066406h-43.34375v-282.589844h300v12.105469.011719.007812 56 .011719.007812 55.972657.011718.007813 56 .011719.007812zm0-396v26h-300v-26c0-5.515625 4.484375-10 10-10h280c5.515625 0 10 4.484375 10 10zm-10-30h-198v-26c0-5.515625 4.484375-10 10-10h280c5.515625 0 10 4.484375 10 10v26zm0 0"></path><path d="m277.589844 358.019531h-216c-5.523438 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10h216c5.523437 0 10-4.476562 10-10 0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m277.589844 414.011719h-100.589844c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h100.589844c5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"></path><path d="m61.589844 322h153.042968c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-153.042968c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"></path><path d="m277.589844 246.011719h-216c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h216c5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"></path><path d="m61.589844 209.988281h75.519531c5.523437 0 10-4.476562 10-10 0-5.519531-4.476563-10-10-10h-75.519531c-5.523438 0-10 4.480469-10 10 0 5.523438 4.476562 10 10 10zm0 0"></path><path d="m277.589844 189.988281h-88.832032c-5.523437 0-10 4.480469-10 10 0 5.523438 4.476563 10 10 10h88.832032c5.523437 0 10-4.476562 10-10 0-5.519531-4.476563-10-10-10zm0 0"></path><path d="m277.589844 302h-16.390625c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h16.390625c5.523437 0 10-4.476562 10-10s-4.476563-10-10-10zm0 0"></path><path d="m422 246c-2.628906 0-5.210938 1.070312-7.070312 2.929688-1.859376 1.859374-2.929688 4.441406-2.929688 7.070312s1.070312 5.210938 2.929688 7.070312c1.859374 1.859376 4.441406 2.929688 7.070312 2.929688s5.210938-1.070312 7.070312-2.929688c1.859376-1.859374 2.929688-4.441406 2.929688-7.070312s-1.070312-5.210938-2.929688-7.070312c-1.859374-1.859376-4.441406-2.929688-7.070312-2.929688zm0 0"></path></svg>
                      </span>
                      <span style="font-size:18.5px;font-weight:600;">Filer</span>
                    </button>
                    <button class="mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center" @click="showMeetingDetailsCommenttext(item)" v-if="item.comment_to_partner !== ''">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M372.3 50.8H28.8C12.9 50.8 0 63.7 0 79.6v206.1c0 15.9 12.9 28.8 28.8 28.8h22.3v76.7c0 4.9 2.9 9.3 7.5 11.2 1.5 0.6 3.1 0.9 4.6 0.9 3.1 0 6.2-1.2 8.5-3.5l85.3-85.2h17.1c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1 0 0-22.7 0-22.9 0 -2.8 0.2-5.6 1.3-7.7 3.5l-68.2 68.2c0 0 0-60.4-0.1-60.7 -0.5-6.2-5.7-11-12-11H28.8c-2.6 0-4.7-2.1-4.7-4.7V79.6c0-2.6 2.1-4.7 4.7-4.7H372.3c2.6 0 4.7 2.1 4.7 4.7v79.1c0 6.7 5.4 12.1 12.1 12.1s12.1-5.4 12.1-12.1V79.6C401.1 63.7 388.2 50.8 372.3 50.8z"/><path d="M483.2 198.5H242.8c-15.9 0-28.8 12.9-28.8 28.8v140.6c0 15.9 12.9 28.8 28.8 28.8h150.5l61 61c2.3 2.3 5.4 3.5 8.5 3.5 1.6 0 3.1-0.3 4.6-0.9 4.5-1.9 7.5-6.3 7.5-11.2v-52.4h8.3c15.9 0 28.8-12.9 28.8-28.8V227.3C512 211.4 499.1 198.5 483.2 198.5zM487.8 367.9c0 2.6-2.1 4.7-4.7 4.7h-20.4c-6.4 0-11.6 4.9-12 11.1 0 0.3-0.1 36.3-0.1 36.3l-43.9-43.9c0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.3-0.3-0.5-0.4 -2.1-1.9-4.9-3-8-3H242.8c-2.6 0-4.7-2.1-4.7-4.7v-140.6c0-2.6 2.1-4.7 4.7-4.7h240.4c2.6 0 4.7 2.1 4.7 4.7V367.9z"/><path d="M363 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C375 290.9 369.6 285.5 363 285.5z"/><path d="M310.5 130.6c0 0-219.8 0-219.8 0 -6.7 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1h219.8c6.7 0 12.1-5.4 12.1-12.1S317.1 130.6 310.5 130.6z"/><path d="M174.1 210.5H90.7c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1h83.4c6.7 0 12.1-5.4 12.1-12.1S180.7 210.5 174.1 210.5z"/><path d="M306.8 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C318.9 290.9 313.5 285.5 306.8 285.5z"/><path d="M419.1 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C431.2 290.9 425.7 285.5 419.1 285.5z"/></svg>
                      </span>
                      <span class="h5 line-height-1 mb0">Kommentar</span>
                    </button>
                    <!-- opret tilbud button -->
                    <button class="mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center" @click="showMeetingTilbud(item)">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M446 0h-280c-5.5 0-10 4.5-10 10s4.5 10 10 10h280c5.5 0 10 4.5 10 10v452c0 5.5-4.5 10-10 10h-380c-5.5 0-10-4.5-10-10V30c0-5.5 4.5-10 10-10h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20c-16.5 0-30 13.5-30 30v452c0 16.5 13.5 30 30 30h380c16.5 0 30-13.5 30-30V30C476 13.5 462.5 0 446 0z"/><path d="M436 50c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v80c0 5.5 4.5 10 10 10h340c5.5 0 10-4.5 10-10V50zM416 120h-320V60h320V120z"/><path d="M381 472h45c5.5 0 10-4.5 10-10V170c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v292c0 5.5 4.5 10 10 10h215c5.5 0 10-4.5 10-10s-4.5-10-10-10h-35V326h150v126h-35c-5.5 0-10 4.5-10 10S375.5 472 381 472zM246 180v126h-150V180H246zM246 452h-150V326h150V452zM266 306V180h150v126H266z"/><path d="M141 253h20v20c0 5.5 4.5 10 10 10s10-4.5 10-10v-20h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20v-20c0-5.5-4.5-10-10-10s-10 4.5-10 10v20h-20c-5.5 0-10 4.5-10 10S135.5 253 141 253z"/><path d="M142.7 417.3c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l42.4-42.4c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-42.4 42.4C138.8 407 138.8 413.4 142.7 417.3z"/><path d="M371 233h-60c-5.5 0-10 4.5-10 10s4.5 10 10 10h60c5.5 0 10-4.5 10-10S376.5 233 371 233z"/><path d="M362.2 420.2c2.6 0 5.1-1 7.1-2.9 3.9-3.9 3.9-10.2 0-14.1l-14.1-14.1 14.1-14.1c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-14.1 14.1 -14.1-14.1c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l14.1 14.1 -14.1 14.1c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l14.1-14.1 14.1 14.1C357.1 419.2 359.7 420.2 362.2 420.2z"/><path d="M126 20c5.5 0 10-4.5 10-10s-4.5-10-10-10h0c-5.5 0-10 4.5-10 10S120.5 20 126 20z"/><path d="M341 452c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10 -4.5-10-10-10H341z"/></svg>
                      </span>
                      <span class="h6 ml1">Se tilbud</span>
                    </button>
                    <button class="mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center" v-if="item.id_appointment_status_support === '0' && item.reklamationb === 1" @click="showMeetingDetailsAflyse(item)">
                      <span style="font-size:18.5px;font-weight:600;">Reklamation</span>
                    </button>
                    <button class="mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center" v-if="item.id_appointment_status_support === '0' && item.changedate === '1' && item.aflyseb === 1" @click="showMeetingDetailsDate(item)">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502 56h-51.6v-6.1c0-19.3-15.7-35-35-35s-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-51.6c-5.5 0-10 4.5-10 10v78.6 102.6C41.4 260.7 0 310.8 0 370.4c0 53.3 33.7 101.3 83.9 119.3 1.1 0.4 2.3 0.6 3.4 0.6 4.1 0 7.9-2.5 9.4-6.6 1.9-5.2-0.8-10.9-6-12.8C48.4 455.7 20 415.3 20 370.4c0-52.8 38.6-96.8 89-105.2 16.2-2.7 35-0.9 51.2 4 10.5 3.2 20.3 8.3 29.1 14.9 8.8 6.6 16.8 14.4 23.5 23.1 6.7 8.7 11.9 18.5 15 29 3.4 11.5 4.4 23.5 5.2 35.4 0.6 10.3-1.6 20.7-4.4 30.6 -2.1 7.7-5.3 15-9.5 21.8 -4.1 6.7-8.9 13-14.1 18.9 -5.3 5.9-11.3 11.3-17.9 15.8 -6.8 4.5-14.1 8-21.6 11.2 -0.9 0.4-1.8 0.8-2.7 1.2 -5.2 1.9-7.9 7.6-6 12.8 1.9 5.2 7.6 7.9 12.8 6 40.6-14.6 70.4-48.7 80.3-89.5H462c5.5 0 10-4.5 10-10s-4.5-10-10-10H253c0.4 0 0.2-14.4 0.1-15.6 -1-22.1-7.7-44.2-19.7-62.8 -10.5-16.4-25.3-30.2-41.9-40.3 -16.1-9.8-33.9-15.4-52.6-17.2 -1.6-0.2-22.1-1.3-22.1-0.3v-89.5H492v195.6c0 5.5 4.5 10 10 10s10-4.5 10-10V144.6 66C512 60.5 507.5 56 502 56zM400.4 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15 -8.3 0-15-6.7-15-15V49.9zM289.5 49.9c0-8.3 6.7-15 15-15s15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM178.5 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM116.9 134.6V76h41.6v6.1c0 19.3 15.7 35 35 35 19.3 0 35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1H492v58.6H116.9z"/><path d="M126.7 294.7c-5.5 0-10 4.5-10 10v55.7H83.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h43.6c5.5 0 10-4.5 10-10v-65.7C136.7 299.1 132.2 294.7 126.7 294.7z"/><path d="M126.7 477.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C136.7 481.6 132.2 477.1 126.7 477.1z"/><path d="M502 380.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C512 384.7 507.5 380.2 502 380.2z"/></svg>
                      </span>
                      <span style="font-size:18.5px;font-weight:600;">Skift dato</span>
                    </button>
                    <button class="mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center" v-if="item.id_appointment_status_support === '0' && item.aflyseb === 1" @click="showMeetingDetailsAflyse(item)">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M437 75C388.7 26.6 324.4 0 256 0S123.3 26.6 75 75C26.6 123.3 0 187.6 0 256s26.6 132.7 75 181C123.3 485.4 187.6 512 256 512s132.7-26.6 181-75C485.4 388.7 512 324.4 512 256S485.4 123.3 437 75zM256 491.6c-129.9 0-235.6-105.7-235.6-235.6S126.1 20.4 256 20.4 491.6 126.1 491.6 256 385.9 491.6 256 491.6z"/><path d="M318 256l84.8-84.7c4-4 4-10.4 0-14.4l-47.6-47.6c-4-4-10.4-4-14.4 0L256 194l-84.7-84.7c-4-4-10.4-4-14.4 0l-47.6 47.6c-4 4-4 10.4 0 14.4L194 256l-84.7 84.7c-4 4-4 10.4 0 14.4l47.6 47.6c4 4 10.4 4 14.4 0L256 318l84.8 84.7c2 2 4.6 3 7.2 3s5.2-1 7.2-3l47.6-47.6c4-4 4-10.4 0-14.4L318 256zM348 381.1l-84.7-84.7c-2-2-4.6-3-7.2-3s-5.2 1-7.2 3l-84.7 84.8 -33.2-33.2 84.8-84.7c4-4 4-10.4 0-14.4l-84.7-84.7 33.2-33.2 84.7 84.8c4 4 10.4 4 14.4 0l84.7-84.7 33.2 33.2 -84.7 84.7c-4 4-4 10.4 0 14.4l84.8 84.7L348 381.1z"/><path d="M476.7 238.9c-0.4-5.6-5.3-9.8-11-9.4 -5.6 0.4-9.8 5.3-9.4 11 2.2 28.5-1.8 57.7-11.5 84.5 -1.9 5.3 0.8 11.1 6.1 13.1 1.2 0.4 2.3 0.6 3.5 0.6 4.2 0 8.1-2.6 9.6-6.7C474.7 302.4 479.1 270.3 476.7 238.9z"/><path d="M469.4 197.2c-0.9-3.2-1.9-6.5-2.9-9.6 -1.7-5.4-7.5-8.3-12.8-6.6 -5.4 1.7-8.3 7.5-6.6 12.8 0.9 2.9 1.8 5.8 2.6 8.7 1.2 4.5 5.3 7.5 9.8 7.5 0.9 0 1.8-0.1 2.7-0.4C467.7 208.2 470.9 202.6 469.4 197.2z"/></svg>
                      </span>
                      <span style="font-size:18.5px;font-weight:600;">Aflyse</span>
                    </button>
                  </div>
                </div>
                <!-- if henttilbud column -->
                <div class="col-12 px0 gibson" v-if="item.henttilbud === 1">
                  <a :href="'mailto:' + item.email" class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center no-hover">
                    <span class="mr2 relative" style="top:3px;">
                      <svg fill="currentColor" width="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"/><path d="M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"/><path d="M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"/></svg>
                    </span>
                    <span class="h6 line-height-1 mb0">{{item.email}}</span>
                  </a>
                  <div class="flex flex-column">
                    <button class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center" @click="prisUrlOpen(item)" v-if="item.potentialnameurl !== ''">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M85.7 49c-20.2 0-36.7 16.5-36.7 36.7s16.5 36.7 36.7 36.7c20.2 0 36.7-16.5 36.7-36.7S105.9 49 85.7 49zM85.7 102c-9 0-16.3-7.3-16.3-16.3 0-9 7.3-16.3 16.3-16.3s16.3 7.3 16.3 16.3C102 94.7 94.7 102 85.7 102z"/><path d="M499.2 265.2L279.6 45.6c-6.5-6.5-14.8-10.8-23.9-12.2L50.5 0.6C36.5-1.7 22.8 2.8 12.8 12.8 2.8 22.8-1.7 36.5 0.6 50.5l32.8 205.2c1.5 9.1 5.7 17.4 12.2 23.9l219.6 219.6c8.2 8.2 19.2 12.8 30.8 12.8 11.6 0 22.6-4.5 30.8-12.8l172.4-172.4C516.2 309.8 516.2 282.2 499.2 265.2zM484.8 312.4L312.4 484.8c-9 9-23.8 9-32.8 0L60 265.2c-3.5-3.5-5.7-7.9-6.5-12.7L20.7 47.3c-1.2-7.4 1.2-14.7 6.5-20.1 4.4-4.4 10.2-6.8 16.3-6.8 1.2 0 2.5 0.1 3.8 0.3l205.2 32.8c4.9 0.8 9.3 3 12.7 6.5l219.6 219.6v0C493.9 288.7 493.9 303.4 484.8 312.4z"/><path d="M323.4 188.6c-4-4-10.4-4-14.4 0L188.6 309c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3L323.4 203C327.4 199.1 327.4 192.6 323.4 188.6z"/><path d="M364.2 229.4c-4-4-10.4-4-14.4 0l-3.1 3.1c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3l3.1-3.1C368.2 239.9 368.2 233.4 364.2 229.4z"/><path d="M337.7 255.9c-4-4-10.4-4-14.4 0l-93.8 93.8c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3l93.8-93.8C341.7 266.4 341.7 259.9 337.7 255.9z"/></svg>
                      </span>
                      <span class="h6 line-height-1 mb0" style="font-weight:600!important;">Prisoverslag</span>
                    </button>
                    <a class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center no-hover" @click="getdataigibility(item.id_appointment, item.contact_id)" >
                      <span class="mr2 relative">
                        <img src="static/svg/globe.svg" width="70%">
                      </span>
                      <span class="h6 line-height-1 mb0">Klima profil</span>
                    </a>
                    <button class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center" @click="prisUrlOpenFile(item)" v-if="item.potentialnameurl !== '' && item.numoffile > 0">
                    <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" viewBox="-40 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m402 0h-280c-16.542969 0-30 13.457031-30 30v26h-62c-16.542969 0-30 13.457031-30 30v338.589844c.0078125.007812.015625.015625.0234375.019531.0039063 2.59375.9960935 5.144531 2.9062505 7.050781l77.40625 77.410156c1.914062 1.914063 4.472656 2.929688 7.074218 2.929688h.011719 222.578125c16.542969 0 30-13.457031 30-30v-26h62c16.542969 0 30-13.457031 30-30v-125c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v125c0 5.515625-4.484375 10-10 10h-62v-57.863281h29.539062c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-29.539062v-35.992188h29.539062c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10h-29.539062v-36.019531h29.539062c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-29.539062v-35.988281h29.539062c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-29.539062v-36.023438h29.539062c5.523438 0 10-4.476562 10-10 0-5.519531-4.476562-10-10-10h-29.539062v-48.113281c0-3.507812-.609375-6.871094-1.71875-10h73.71875v135c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-181c0-16.542969-13.457031-30-30-30zm-324.589844 477.859375-43.269531-43.269531h29.203125c7.753906 0 14.066406 6.3125 14.066406 14.066406zm242.589844 4.140625c0 5.515625-4.484375 10-10 10h-212.589844v-43.34375c0-18.785156-15.28125-34.066406-34.066406-34.066406h-43.34375v-282.589844h300v12.105469.011719.007812 56 .011719.007812 55.972657.011718.007813 56 .011719.007812zm0-396v26h-300v-26c0-5.515625 4.484375-10 10-10h280c5.515625 0 10 4.484375 10 10zm-10-30h-198v-26c0-5.515625 4.484375-10 10-10h280c5.515625 0 10 4.484375 10 10v26zm0 0"></path><path d="m277.589844 358.019531h-216c-5.523438 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10h216c5.523437 0 10-4.476562 10-10 0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m277.589844 414.011719h-100.589844c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h100.589844c5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"></path><path d="m61.589844 322h153.042968c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-153.042968c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"></path><path d="m277.589844 246.011719h-216c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h216c5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"></path><path d="m61.589844 209.988281h75.519531c5.523437 0 10-4.476562 10-10 0-5.519531-4.476563-10-10-10h-75.519531c-5.523438 0-10 4.480469-10 10 0 5.523438 4.476562 10 10 10zm0 0"></path><path d="m277.589844 189.988281h-88.832032c-5.523437 0-10 4.480469-10 10 0 5.523438 4.476563 10 10 10h88.832032c5.523437 0 10-4.476562 10-10 0-5.519531-4.476563-10-10-10zm0 0"></path><path d="m277.589844 302h-16.390625c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h16.390625c5.523437 0 10-4.476562 10-10s-4.476563-10-10-10zm0 0"></path><path d="m422 246c-2.628906 0-5.210938 1.070312-7.070312 2.929688-1.859376 1.859374-2.929688 4.441406-2.929688 7.070312s1.070312 5.210938 2.929688 7.070312c1.859374 1.859376 4.441406 2.929688 7.070312 2.929688s5.210938-1.070312 7.070312-2.929688c1.859376-1.859374 2.929688-4.441406 2.929688-7.070312s-1.070312-5.210938-2.929688-7.070312c-1.859374-1.859376-4.441406-2.929688-7.070312-2.929688zm0 0"></path></svg>
                      </span>
                      <span style="font-size:18.5px;font-weight:600;">Filer</span>
                    </button>
                    <button class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center" @click="showMeetingDetailsCommentCustomertext(item)" v-if="item.comment_to_customer !== ''">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="m459.7 67.9-60.1-60.1c-5-5-11.6-7.8-18.7-7.8h-194.3c-14.6 0-26.5 11.9-26.5 26.5v58.3h-101.1c-14.6 0-26.5 11.9-26.5 26.5v169.7c0 12.9 20 12.8 20 0v-169.7c0-3.6 2.9-6.5 6.5-6.5h190v44.7c0 14.6 11.9 26.5 26.5 26.5h44.4v297.6c0 3.6-2.9 6.5-6.5 6.5h-254.4c-3.6 0-6.5-2.9-6.5-6.5v-110.7c0-12.9-20-12.8-20 0v110.7c0 14.6 11.9 26.5 26.5 26.5h254.4c14.6 0 26.5-11.9 26.5-26.5v-58.3h101.1c14.6 0 26.5-11.9 26.5-26.5v-302.2c0-7.1-2.8-13.7-7.8-18.7zm-25 3.3h-31.6c-3.6 0-6.5-2.9-6.5-6.5v-31.6zm-165.7 78.3v-31.6l38.1 38.1h-31.6c-3.6 0-6.5-2.9-6.5-6.5zm171.9 245.7h-101.1v-223.9c0-7.1-2.8-13.7-7.8-18.7l-60.1-60.1c-5-5-11.6-7.8-18.7-7.8h-73.1v-58.3c0-3.6 2.9-6.5 6.5-6.5h190v44.7c0 14.6 11.9 26.5 26.5 26.5h44.4v297.6c0 3.6-2.9 6.5-6.5 6.5z"/><path d="m99.4 213.3h69.1c12.8 0 12.9-20 0-20h-69.1c-12.8 0-12.9 20 0 20z"/><path d="m99.4 255.2h172.5c12.8 0 12.9-20 0-20h-172.5c-12.8 0-12.9 20 0 20z"/><path d="m99.4 299.7h172.5c12.8 0 12.9-20 0-20h-172.5c-12.8 0-12.9 20 0 20z"/><path d="m99.4 342.9h172.5c12.8 0 12.9-20 0-20h-172.5c-12.8 0-12.9 20 0 20z"/><path d="m99.4 386.1h172.5c12.8 0 12.9-20 0-20h-172.5c-12.8 0-12.9 20 0 20z"/><path d="m42.5 331.7c4.9 0 9.2-3.7 9.9-8.5 1.4-9.2-10.1-15.1-16.8-8.7-6.4 6.1-1.9 17.2 6.9 17.2z"/></svg>
                      </span>
                      <span style="font-size:18.5px;font-weight:600;">Opgavens indhold</span>
                    </button>
                    <button class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center" @click="showMeetingDetailsCommenttext(item)"  v-if="item.comment_to_partner !== ''">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M372.3 50.8H28.8C12.9 50.8 0 63.7 0 79.6v206.1c0 15.9 12.9 28.8 28.8 28.8h22.3v76.7c0 4.9 2.9 9.3 7.5 11.2 1.5 0.6 3.1 0.9 4.6 0.9 3.1 0 6.2-1.2 8.5-3.5l85.3-85.2h17.1c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1 0 0-22.7 0-22.9 0 -2.8 0.2-5.6 1.3-7.7 3.5l-68.2 68.2c0 0 0-60.4-0.1-60.7 -0.5-6.2-5.7-11-12-11H28.8c-2.6 0-4.7-2.1-4.7-4.7V79.6c0-2.6 2.1-4.7 4.7-4.7H372.3c2.6 0 4.7 2.1 4.7 4.7v79.1c0 6.7 5.4 12.1 12.1 12.1s12.1-5.4 12.1-12.1V79.6C401.1 63.7 388.2 50.8 372.3 50.8z"/><path d="M483.2 198.5H242.8c-15.9 0-28.8 12.9-28.8 28.8v140.6c0 15.9 12.9 28.8 28.8 28.8h150.5l61 61c2.3 2.3 5.4 3.5 8.5 3.5 1.6 0 3.1-0.3 4.6-0.9 4.5-1.9 7.5-6.3 7.5-11.2v-52.4h8.3c15.9 0 28.8-12.9 28.8-28.8V227.3C512 211.4 499.1 198.5 483.2 198.5zM487.8 367.9c0 2.6-2.1 4.7-4.7 4.7h-20.4c-6.4 0-11.6 4.9-12 11.1 0 0.3-0.1 36.3-0.1 36.3l-43.9-43.9c0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.3-0.3-0.5-0.4 -2.1-1.9-4.9-3-8-3H242.8c-2.6 0-4.7-2.1-4.7-4.7v-140.6c0-2.6 2.1-4.7 4.7-4.7h240.4c2.6 0 4.7 2.1 4.7 4.7V367.9z"/><path d="M363 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C375 290.9 369.6 285.5 363 285.5z"/><path d="M310.5 130.6c0 0-219.8 0-219.8 0 -6.7 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1h219.8c6.7 0 12.1-5.4 12.1-12.1S317.1 130.6 310.5 130.6z"/><path d="M174.1 210.5H90.7c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1h83.4c6.7 0 12.1-5.4 12.1-12.1S180.7 210.5 174.1 210.5z"/><path d="M306.8 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C318.9 290.9 313.5 285.5 306.8 285.5z"/><path d="M419.1 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C431.2 290.9 425.7 285.5 419.1 285.5z"/></svg>
                      </span>
                      <span class="h6 line-height-1 mb0">Kommentarer</span>
                    </button>
                    <!-- opret tilbud button -->
                    <button class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center" @click="showMeetingTilbud(item)">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M446 0h-280c-5.5 0-10 4.5-10 10s4.5 10 10 10h280c5.5 0 10 4.5 10 10v452c0 5.5-4.5 10-10 10h-380c-5.5 0-10-4.5-10-10V30c0-5.5 4.5-10 10-10h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20c-16.5 0-30 13.5-30 30v452c0 16.5 13.5 30 30 30h380c16.5 0 30-13.5 30-30V30C476 13.5 462.5 0 446 0z"/><path d="M436 50c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v80c0 5.5 4.5 10 10 10h340c5.5 0 10-4.5 10-10V50zM416 120h-320V60h320V120z"/><path d="M381 472h45c5.5 0 10-4.5 10-10V170c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v292c0 5.5 4.5 10 10 10h215c5.5 0 10-4.5 10-10s-4.5-10-10-10h-35V326h150v126h-35c-5.5 0-10 4.5-10 10S375.5 472 381 472zM246 180v126h-150V180H246zM246 452h-150V326h150V452zM266 306V180h150v126H266z"/><path d="M141 253h20v20c0 5.5 4.5 10 10 10s10-4.5 10-10v-20h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20v-20c0-5.5-4.5-10-10-10s-10 4.5-10 10v20h-20c-5.5 0-10 4.5-10 10S135.5 253 141 253z"/><path d="M142.7 417.3c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l42.4-42.4c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-42.4 42.4C138.8 407 138.8 413.4 142.7 417.3z"/><path d="M371 233h-60c-5.5 0-10 4.5-10 10s4.5 10 10 10h60c5.5 0 10-4.5 10-10S376.5 233 371 233z"/><path d="M362.2 420.2c2.6 0 5.1-1 7.1-2.9 3.9-3.9 3.9-10.2 0-14.1l-14.1-14.1 14.1-14.1c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-14.1 14.1 -14.1-14.1c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l14.1 14.1 -14.1 14.1c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l14.1-14.1 14.1 14.1C357.1 419.2 359.7 420.2 362.2 420.2z"/><path d="M126 20c5.5 0 10-4.5 10-10s-4.5-10-10-10h0c-5.5 0-10 4.5-10 10S120.5 20 126 20z"/><path d="M341 452c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10 -4.5-10-10-10H341z"/></svg>
                      </span>
                      <span class="h6 ml1">Se tilbud</span>
                    </button>
                    <button class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center" @click="showMeetingTilbudbitrix(item, 'kundematch')">
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M446 0h-280c-5.5 0-10 4.5-10 10s4.5 10 10 10h280c5.5 0 10 4.5 10 10v452c0 5.5-4.5 10-10 10h-380c-5.5 0-10-4.5-10-10V30c0-5.5 4.5-10 10-10h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20c-16.5 0-30 13.5-30 30v452c0 16.5 13.5 30 30 30h380c16.5 0 30-13.5 30-30V30C476 13.5 462.5 0 446 0z"/><path d="M436 50c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v80c0 5.5 4.5 10 10 10h340c5.5 0 10-4.5 10-10V50zM416 120h-320V60h320V120z"/><path d="M381 472h45c5.5 0 10-4.5 10-10V170c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v292c0 5.5 4.5 10 10 10h215c5.5 0 10-4.5 10-10s-4.5-10-10-10h-35V326h150v126h-35c-5.5 0-10 4.5-10 10S375.5 472 381 472zM246 180v126h-150V180H246zM246 452h-150V326h150V452zM266 306V180h150v126H266z"/><path d="M141 253h20v20c0 5.5 4.5 10 10 10s10-4.5 10-10v-20h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20v-20c0-5.5-4.5-10-10-10s-10 4.5-10 10v20h-20c-5.5 0-10 4.5-10 10S135.5 253 141 253z"/><path d="M142.7 417.3c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l42.4-42.4c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-42.4 42.4C138.8 407 138.8 413.4 142.7 417.3z"/><path d="M371 233h-60c-5.5 0-10 4.5-10 10s4.5 10 10 10h60c5.5 0 10-4.5 10-10S376.5 233 371 233z"/><path d="M362.2 420.2c2.6 0 5.1-1 7.1-2.9 3.9-3.9 3.9-10.2 0-14.1l-14.1-14.1 14.1-14.1c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-14.1 14.1 -14.1-14.1c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l14.1 14.1 -14.1 14.1c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l14.1-14.1 14.1 14.1C357.1 419.2 359.7 420.2 362.2 420.2z"/><path d="M126 20c5.5 0 10-4.5 10-10s-4.5-10-10-10h0c-5.5 0-10 4.5-10 10S120.5 20 126 20z"/><path d="M341 452c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10 -4.5-10-10-10H341z"/></svg>
                      </span>
                      <span class="h6 ml1">Opret tilbud</span>
                    </button>
                    <!-- Giv os Feedback -->
                    <button class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center" @click="openFeedback(item)" >
                      <span class="mr2 relative" style="top:2px;">
                        <svg fill="currentColor" width="30" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M372.3 50.8H28.8C12.9 50.8 0 63.7 0 79.6v206.1c0 15.9 12.9 28.8 28.8 28.8h22.3v76.7c0 4.9 2.9 9.3 7.5 11.2 1.5 0.6 3.1 0.9 4.6 0.9 3.1 0 6.2-1.2 8.5-3.5l85.3-85.2h17.1c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1 0 0-22.7 0-22.9 0 -2.8 0.2-5.6 1.3-7.7 3.5l-68.2 68.2c0 0 0-60.4-0.1-60.7 -0.5-6.2-5.7-11-12-11H28.8c-2.6 0-4.7-2.1-4.7-4.7V79.6c0-2.6 2.1-4.7 4.7-4.7H372.3c2.6 0 4.7 2.1 4.7 4.7v79.1c0 6.7 5.4 12.1 12.1 12.1s12.1-5.4 12.1-12.1V79.6C401.1 63.7 388.2 50.8 372.3 50.8z"/><path d="M483.2 198.5H242.8c-15.9 0-28.8 12.9-28.8 28.8v140.6c0 15.9 12.9 28.8 28.8 28.8h150.5l61 61c2.3 2.3 5.4 3.5 8.5 3.5 1.6 0 3.1-0.3 4.6-0.9 4.5-1.9 7.5-6.3 7.5-11.2v-52.4h8.3c15.9 0 28.8-12.9 28.8-28.8V227.3C512 211.4 499.1 198.5 483.2 198.5zM487.8 367.9c0 2.6-2.1 4.7-4.7 4.7h-20.4c-6.4 0-11.6 4.9-12 11.1 0 0.3-0.1 36.3-0.1 36.3l-43.9-43.9c0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.3-0.3-0.5-0.4 -2.1-1.9-4.9-3-8-3H242.8c-2.6 0-4.7-2.1-4.7-4.7v-140.6c0-2.6 2.1-4.7 4.7-4.7h240.4c2.6 0 4.7 2.1 4.7 4.7V367.9z"/><path d="M363 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C375 290.9 369.6 285.5 363 285.5z"/><path d="M310.5 130.6c0 0-219.8 0-219.8 0 -6.7 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1h219.8c6.7 0 12.1-5.4 12.1-12.1S317.1 130.6 310.5 130.6z"/><path d="M174.1 210.5H90.7c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1h83.4c6.7 0 12.1-5.4 12.1-12.1S180.7 210.5 174.1 210.5z"/><path d="M306.8 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C318.9 290.9 313.5 285.5 306.8 285.5z"/><path d="M419.1 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C431.2 290.9 425.7 285.5 419.1 285.5z"/></svg>
                      </span>
                      <span class="h6 line-height-1 mb0">Giv os Feedback</span>
                    </button>
                  </div>
                </div>
                <div class="col-12 px0 gibson">
                  <button @click="showMeetingDetailsAflysetext(item)" v-if="item.ticketsolution !== '' && item.id_appointment_status_support === '1'" class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center">
                    <span class="mr1 relative" style="top:2px;">
                      <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="1 -26 512 511"><path d="m451.5 459.9h-390.9c-21.8 0-41.4-11.3-52.3-30.2-10.9-18.9-10.9-41.5 0-60.4l195.5-338.6c10.9-18.9 30.5-30.2 52.3-30.2 21.8 0 41.4 11.3 52.3 30.2l81.5 141.2c2.8 4.8 1.1 10.9-3.7 13.7-4.8 2.8-10.9 1.1-13.7-3.7l-81.5-141.2c-7.3-12.7-20.4-20.2-35-20.2s-27.7 7.6-35 20.2l-195.5 338.6c-7.3 12.7-7.3 27.8 0 40.4 7.3 12.7 20.4 20.2 35 20.2h390.9c14.6 0 27.7-7.6 35-20.2 7.3-12.7 7.3-27.8 0-40.4l-68.9-119.4c-2.8-4.8-1.1-10.9 3.7-13.7 4.8-2.8 10.9-1.1 13.7 3.7l68.9 119.4c10.9 18.9 10.9 41.5 0 60.4-10.9 18.9-30.5 30.2-52.3 30.2zm0 0"/><path d="m403.7 225.9c-2.6 0-5.2-1.1-7.1-2.9-1.9-1.9-2.9-4.4-2.9-7.1 0-2.6 1.1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9 2.6 0 5.2 1.1 7.1 2.9 1.9 1.9 2.9 4.4 2.9 7.1 0 2.6-1.1 5.2-2.9 7.1-1.9 1.9-4.4 2.9-7.1 2.9zm0 0"/><path d="m256 375.8c-18.7 0-34-15.2-34-34 0-18.7 15.3-34 34-34s34 15.3 34 34c0 18.7-15.2 34-34 34zm0-48c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14zm0 0"/><path d="m256 282.1c-18.7 0-34-15.2-34-34v-84.2c0-18.7 15.3-34 34-34s34 15.3 34 34v84.2c0 18.8-15.2 34-34 34zm0-132.2c-7.7 0-14 6.3-14 14v84.2c0 7.7 6.3 14 14 14s14-6.3 14-14v-84.2c0-7.7-6.3-14-14-14zm0 0"/></svg>
                    </span>
                    <span>{{item.ticketcategory}} {{item.ticketstatus}}</span>
                  </button>
                  <p v-if="item.ticketsolution === ''" class="mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center">
                    <span class="mr1 relative" style="top:2px;">
                      <svg fill="currentColor" width="18" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="1 -26 512 511"><path d="m451.5 459.9h-390.9c-21.8 0-41.4-11.3-52.3-30.2-10.9-18.9-10.9-41.5 0-60.4l195.5-338.6c10.9-18.9 30.5-30.2 52.3-30.2 21.8 0 41.4 11.3 52.3 30.2l81.5 141.2c2.8 4.8 1.1 10.9-3.7 13.7-4.8 2.8-10.9 1.1-13.7-3.7l-81.5-141.2c-7.3-12.7-20.4-20.2-35-20.2s-27.7 7.6-35 20.2l-195.5 338.6c-7.3 12.7-7.3 27.8 0 40.4 7.3 12.7 20.4 20.2 35 20.2h390.9c14.6 0 27.7-7.6 35-20.2 7.3-12.7 7.3-27.8 0-40.4l-68.9-119.4c-2.8-4.8-1.1-10.9 3.7-13.7 4.8-2.8 10.9-1.1 13.7 3.7l68.9 119.4c10.9 18.9 10.9 41.5 0 60.4-10.9 18.9-30.5 30.2-52.3 30.2zm0 0"/><path d="m403.7 225.9c-2.6 0-5.2-1.1-7.1-2.9-1.9-1.9-2.9-4.4-2.9-7.1 0-2.6 1.1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9 2.6 0 5.2 1.1 7.1 2.9 1.9 1.9 2.9 4.4 2.9 7.1 0 2.6-1.1 5.2-2.9 7.1-1.9 1.9-4.4 2.9-7.1 2.9zm0 0"/><path d="m256 375.8c-18.7 0-34-15.2-34-34 0-18.7 15.3-34 34-34s34 15.3 34 34c0 18.7-15.2 34-34 34zm0-48c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14zm0 0"/><path d="m256 282.1c-18.7 0-34-15.2-34-34v-84.2c0-18.7 15.3-34 34-34s34 15.3 34 34v84.2c0 18.8-15.2 34-34 34zm0-132.2c-7.7 0-14 6.3-14 14v84.2c0 7.7 6.3 14 14 14s14-6.3 14-14v-84.2c0-7.7-6.3-14-14-14zm0 0"/></svg>
                    </span>
                    <span><!-- {{ item.ticketcategory }}: -->{{item.ticketstatus}}</span>
                  </p>
                </div>
                <button @click="mailSupport(item.contactid)" class="mb1 outlined-button px2 col-12 py1 white-background collapsebutton not-rounded flex justify-center items-center">
                  <span class="relative col-4 flex justify-end pr2 ">
                    <svg fill="currentColor" width="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"/><path d="M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"/><path d="M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"/></svg>
                  </span>
                  <span class="h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start">Skriv til kunden</span>
                </button>
                <button @click="openComment(item)" class="mb1 outlined-button px2 col-12 py1 white-background collapsebutton not-rounded flex justify-center items-center">
                  <span class="relative col-4 flex justify-end pr2">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="28" preserveAspectRatio="xMinYMin" class="jam jam-document"><path d='M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm2 1h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2zm0 12h2a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm0-4h6a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm0-4h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2z'/></svg>
                  </span>
                  <span class="h6 mb0 semi-bold col-8 p0 flex justify-start">Dine notater <span class="badge badge-pill regular relative primarycolor-background ml1" style="top:-2px;">{{item.notat}}</span></span>
                </button>
                <button v-b-toggle="'setReminder'+item.id_appointment" :id="'setReminderb'+item.id_appointment" class="mb1 outlined-button px2 py1 white-background col-12 collapsebutton not-rounded flex justify-center items-center">
                  <template>
                    <!-- if date is set show -->
                    <div class="flex justify-start items-center regular">
                      <span class="relative mr1" style="top:2px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-bell"><path d='M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A6.987 6.987 0 0 0 2.29 15h13.42a6.987 6.987 0 0 0-2.044-3.218zM12 17a3 3 0 0 1-6 0H0a8.978 8.978 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.978 8.978 0 0 1 18 17h-6zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1z'/></svg>
                      </span>
                      <span v-if="item.remidercount !== 0" class="mb0 semi-bold" style="font-size:18.5px;">
                        {{ moment(item.remiderappid.date).format('ll') }}
                      </span>
                      <span v-if="item.remidercount === 0" class="mb0 semi-bold" style="font-size:18.5px;">
                        Tilføj påmindelse
                      </span>
                    </div>
                  </template>
                </button>
                <button v-if="item.remidercount !== 0 && item.remiderappid.done !== '1'"  @click="handleSletReminder(item,1)" class="p1 outlined-action-button flex justify-center items-center border-none gibson line-height-1">
                  <span class="mr1"><i class="el-icon-check"></i></span>
                </button>
                <button v-if="item.remidercount !== 0" @click="handleSletReminder(item,2)" class="mb1 outlined-button px2 py1 white-background collapsebutton col-12 not-rounded flex justify-center items-center">
                  <span><i class="el-icon-delete"></i></span>
                </button>
                <b-collapse :id="'setReminder'+item.id_appointment" ref="reminderModal" class="col-12">
                  <form @submit.stop.prevent="handleSubmitReminder(item)">
                    <div class="clearfix mb3">
                      <div class="flex flex-column my2">
                        <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Type</span>
                        <select id="reminderSelect" v-model="item.remiderappid.smsemail" required  class="muted-background p1 darkblue not-rounded border-none gibson mb1" style="font-size:16.5px;height:38px;">
                          <option value="1">SMS og email</option>
                          <option value="2">SMS</option>
                          <option value="3">Email</option>
                          <option value="0">None</option>
                        </select>
                      </div>
                      <div class="flex flex-column mt3 mb2">
                        <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Dato</span>
                        <VueCtkDateTimePicker id="reminderDate" v-model="datereminder" locale="da" label="Påmindelse Dato" required placeholder="Påmindelse Dato" class="darkblue not-rounded border-none gibson mb1 muted-background"  />
                      </div>
                      <div class="flex flex-column mb2">
                        <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Noter</span>
                        <textarea name="note" v-model="item.remiderappid.descp"  id="note" cols="30" rows="5" required placeholder="" class="p2 muted-background darkblue gibson line-height-3 border-none not-rounded" style="font-size:13.5px;"></textarea>
                      </div>
                      <div class="clearfix flex flex-column items-center">
                        <div class="col-12 px0">
                          <button v-b-toggle.newclass  class="col-12 action-button p2 line-height-1 flex justify-center items-center border-none not-rounded gibson">
                            <span class="semi-bold" style="font-size:16.5px;">Gem</span>
                            <span class="ml1"><i class="el-icon-right"></i></span>
                          </button>
                        </div>
                        <div class="py1"></div>
                        <div class="col-12 px0">
                          <button type="button" v-b-toggle="'setReminder'+item.id_appointment"  class="col-12 outlined-disabled-button p2 gibson line-height-1 flex justify-center items-center not-rounded">
                            <span class="pr2"><i class="el-icon-back"></i></span>
                            <span style="font-size:16.5px;">Luk påmindelse</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </b-collapse>
              </b-collapse>
            </div>
            <div class="col-12 mb1">
              <button @click="showMeetingTilbudbitrix(item, 'kundematch')" class="kundebutton dark-button col-12 outlined-action-button p1 flex justify-center items-center gibson line-height-1">
                <span class="relative col-4 flex justify-end pr2 ">
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 21.805 13.414">
                    <path id="opret_tilbud" data-name="opret tilbud" d="M.476,13.414A.477.477,0,0,1,0,12.938V3.99a.477.477,0,0,1,.476-.476H1.49L2.337.352A.476.476,0,0,1,2.778,0H2.8a.507.507,0,0,1,.12.015L15.261,3.322a.475.475,0,0,1,.348.395l.317,2.233a2.79,2.79,0,0,1,2.308,1.676,2.819,2.819,0,0,1,.134.385A5.351,5.351,0,0,1,19,7.988h.411a2.374,2.374,0,0,1,1.692.7,2.4,2.4,0,0,1,.7,1.692.476.476,0,1,1-.951,0A1.443,1.443,0,0,0,19.413,8.94c-.15,0-.289,0-.423.007-.113,0-.221.006-.319.006-.078,0-.15,0-.216-.006a2.8,2.8,0,0,1-3.749,2.41l-1.039,1.818a.476.476,0,0,1-.413.24Zm.475-.952H12.978l.9-1.581a2.809,2.809,0,0,1-.875-1.3A1.434,1.434,0,1,1,14,9.2a1.723,1.723,0,0,0,.421.737l.839-1.468-2.285-4H.951Zm14.717-2a1.73,1.73,0,0,0,.414-3.409l.179,1.259a.483.483,0,0,1-.037.388l-.977,1.709A1.722,1.722,0,0,0,15.668,10.462ZM12.55,8.145a.476.476,0,0,0,.328.457,2.8,2.8,0,0,1,.207-.935l-.055,0A.476.476,0,0,0,12.55,8.145Zm2.429-2.1-.268-1.89L13.752,3.9ZM12.3,3.514,3.133,1.058,2.474,3.514Z" fill="#4dcf55"/>
                  </svg> -->
                </span>
                <span class="h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start">OPRET TILBUD</span>
              </button>
            </div>
          </div>
          <!-- use this div for item == pending -->
          <div v-if="item.kundeconfirms === '0'" class="absolute top-0 right-0 left-0 z3 flex justify-center items-center" style="background-color:rgba(178, 190, 195, 0.75);height:95%;">
              <div class="darkblue text-shadow flex flex-column justify-center items-center">
                <div><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="48" height="48" preserveAspectRatio="xMinYMin" class="jam jam-alert"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-13a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/></svg></div>
                <div class="m2 py2">
                  <p class="h6 semi-bold p5 line-height-2 center">Kunden har <Countdown2 :deadline="item.countdown"></Countdown2> dage til at godkende, at de stadig vil videre med opgaven, med dit firma.</p>
                </div>

                <Countdown :deadline="item.countdown"></Countdown>
                <div class="col-6 py2 gibson" >
                  <p class="darkblue regular line-height-3 break-word" style="font-size:18.5px;max-lines:2;">
                    {{ item.mailingzip }} {{ item.mailingcity }}
                  </p>
                </div>
                <p  class="text-left p2 semi-bold">{{ item.comment_to_partner | truncate(300, '...') }}</p>
              </div>

            </div>
          <!-- use this div for item == rejected -->
          <div v-if="item.kundeconfirms === '2'" class="absolute top-0 right-0 left-0 z3 flex justify-center items-center" style="background-color:rgba(255,255,255,.8);height:95%;">

            <template v-if="item.rejectshow === '1'" >
            <div v-b-tooltip.hover.top="item.rejecttext" class="darkblue text-shadow flex flex-column justify-center items-center">
              <div><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="48" height="48" preserveAspectRatio="xMinYMin" class="jam jam-alert"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-13a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/></svg></div>
              <div>
                <p class="h3 semi-bold line-height-1">Afvist</p>
              </div>
              <div class="col-12 gibson" >
                <p class="darkblue regular line-height-3 break-word" style="font-size:18.5px;max-lines:2;">
                  {{ item.mailingzip }} {{ item.mailingcity }}
                </p>
              </div>
            </div>
            </template>
            <template v-if="item.rejectshow !== '1'" >
            <div class="darkblue text-shadow flex flex-column justify-center items-center">
              <div><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="48" height="48" preserveAspectRatio="xMinYMin" class="jam jam-alert"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-13a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/></svg></div>
              <div>
                <p class="h3 semi-bold line-height-1">Afvist</p>
              </div>
              <div class="col-12 gibson" >
                <p class="darkblue regular line-height-3 break-word" style="font-size:18.5px;max-lines:2;">
                  {{ item.mailingzip }} {{ item.mailingcity }}
                </p>
              </div>
            </div>
            </template>

          </div>
        </div>
        <!-- eslint-enable -->
      </div>
      <div class="py4"></div>
    </div>

    <!-- modals -->
    <!-- eslint-enable -->
    <b-modal centered lazy v-model="meetingShow" ref="meetingModal" size="sm" class="p3">
      <!-- header -->
      <div slot="modal-header" class="clearfix px2 pt2 gibson">
        <div class="col-12">
          <p class="h5 semi-bold darkblue line-height-4">{{sampleMeeting.type}}</p>
        </div>
      </div>
      <div class="modal-content p-0 border-0 gibson">
        <div>
          <span class="text-secondary">By</span>
          <br>
          <span class="h5 font-weight-bold">{{ sampleMeeting.city }}</span> <span class="h5 font-weight-bold">{{ sampleMeeting.postnummer }}</span>
          <br><br>
          <span class="text-secondary">Overslagspris eksl. moms</span>
          <br>
          <span class="h5 font-weight-bold text-red">{{ sampleMeeting.estimate }}</span>
          <br><br>
          <span class="text-secondary">Dato</span>
          <br>
          <span class="h5 font-weight-bold">{{ sampleMeeting.date }}</span>
          <br>
        </div>
      </div>
      <!-- modalFooter -->
      <div slot="modal-footer" class="gibson py-4 d-flex justify-content-end w-100">
        <div><b-btn variant="outline-dark" @click="hideModal">Close</b-btn></div>
      </div>
    </b-modal>
    <!-- cancel modal -->
    <b-modal v-model="modalShowAflyseText" hide-footer :title="AflyseTexttitle" class="p3">
      <div class="py2">
        {{ AflyseText }}
      </div>
    </b-modal>
    <!-- prisverslag modal -->
    <b-modal v-model="modalShowPris" class="prisverslag" centered id="modalPopover" title="Prisverslag" ok-only>
      <a class="h4 bold col-right pointer mt2 mr2 no-hover" @click="modalShowPris = false">X</a>
      <div slot="modal-header">
        <h2>Prisoverslag</h2>
      </div>
        <b-embed type="iframe"  scrolling="yes" :src="urlpris+'&frame=1'"   aspect="1by1"  allowfullscreen ></b-embed>
        <div slot="modal-footer" class="col-12 flex justify-start items-center px0">
          <!-- <button type="reset" @click="modalShowPris = false" class="p2 outlined-dark-button line-height-1 gibson not-rounded semi-bold">
            <span class="mr2">
              <i class="el-icon-back"></i>
            </span>
            <span>
              Luk
            </span>
          </button> -->
        </div>
    </b-modal>
    <!-- show kommentar modal -->
    <b-modal v-model="modalShowCommentText" centered class="pt3 pr3 pb1 pl3">
      <p class="h5 darkblue gibson line-height-1 mb3">
        Kommentar
      </p>
      <p class="regular line-height-golden gibson" style="font-size:16.6px;">
        {{ CommentText }}
      </p>
      <div slot="modal-footer" class="col-12 px0 flex justify-start items-center">
        <button @click="modalShowCommentText = false" class="col-3 outlined-dark-button gibson line-height-1 not-rounded p2 flex justify-start items-center">
          <span class="mr2"><i class="el-icon-back"></i></span>
          <span class="mb0 semi-bold">Luk</span>
        </button>
      </div>
    </b-modal>
    <!-- show customer comment modal -->
    <b-modal v-model="modalShowCommentCustomerText" centered class="p3">
      <p class="h5 darkblue semi-bold line-height-1 mb3 gibson">
        Opgavens indhold
      </p>
      <p class="h6 darkblue line-height-4 regular gibson">
        {{ CommentCustomerText }}
      </p>
      <div slot="modal-footer" class="flex justify-start items-center col-12 px0">
        <button type="reset" @click="modalShowCommentCustomerText = false" class="p2 outlined-dark-button gibson h5 line-height1 flex justify-center items-center">
          <span class="mr2"><i class="el-icon-back"></i>
          <span>Luk</span></span>
        </button>
      </div>
    </b-modal>
    <!-- comment modal -->
    <b-modal v-model="modalShowFeedback" no-close-on-backdrop centered class="pt3 pr3 pb1 pl3">
      <div class="p2">
        <p class="h5 darkblue semi-bold line-height-1 my3 gibson">
          Giv os uddybende feedback om kunden : {{kundeitem.firstname}} {{kundeitem.lastname}}
        </p>
        <div class="clearfix">
          <b-form @submit.stop.prevent="handleSubmitFeedback">
            <div class="clearfix">
              <div class="col-12 px0">
                <b-form-textarea v-model="textFeedback" :rows="6" :max-rows="6" placeholder="Tilføj din feedback her..." required class="bg-light border-0"></b-form-textarea>
              </div>
            </div>
            <div class="clearfix mb2 my1">
              <div class="col col-12 p0">
                <button class="col-12 p0 gibson action-button p2 h5 semi-bold not-rounded" type="submit" :disabled="isLoadingAflyse">
                  <span>Feedback</span>
                </button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
      <div slot="modal-footer" class="flex justify-center items-center col-12 px0">
        <button type="reset" @click="modalShowFeedback = false" class="col-4 p2 border-none disabled-button gibson h6 line-height1 flex justify-center items-center left">
        <span>Luk</span>
        </button>
      </div>
    </b-modal>
    <!-- comment modal -->
    <b-modal id="dineNotater" v-model="modalShowkomment" no-close-on-backdrop centered class="pt3 pr3 pb1 pl3">
      <div class="flex justify-end">
        <button type="reset" @click="modalShowkomment = false" class="h4 bold p0 p2 border-none transparent">
          X
        </button>
      </div>
      <div class="p2">
        <p class="h5 darkblue semi-bold line-height-1 my3 gibson">
          Dine notater : {{kundeitem.firstname}} {{kundeitem.lastname}}
        </p>
        <div class="clearfix">
          <div class="col-12 px1 mb2 border-bottom mediumgrey-border" v-for="item in komments" :key="item.id">
            <p class="h7 semi-bold line-height-2 mb0 gibson">{{ item.date }} :
              <button  @click="editComment(item)"  class="not-rounded outlined-action-button p1 border-none">
                <span>
                <i class="el-icon-edit"></i>
                </span>
              </button>
            </p>
            <p class="h7 regular darkblue line-height-4 gibson">{{ item.note }}</p>
            <div class="clearfix">
              <div class="col-12 px0" v-if="item.images.length !== 0">
                <img class="image" :key="image.id" v-for="(image, i) in item.images" :src="image" @click="onClick(item,i)">
                <vue-gallery-slideshow :images="item.images" :index="item.index" @close="item.index = null"></vue-gallery-slideshow>
              </div>
              <div class="col-12 px0" v-if="item.doc.length !== 0">
              <li v-for="attachment in item.doc" :key="attachment.id" class="py-1">
                <a :href="attachment" target="_blank" ><i class="el-icon-paperclip"></i> {{attachment.substring(attachment.lastIndexOf('/')+1)}}</a>
              </li>
              </div>

            </div>
          </div>
        </div>
        <div class="clearfix">
          <b-form @submit.stop.prevent="handleSubmitComment">
            <div class="clearfix mb2">
              <div class="col-12 px0">
                <b-form-textarea v-model="textKomment" :rows="6" :max-rows="6" placeholder="Tilføj din kommentar her..." required class="bg-light border-0"></b-form-textarea>
              </div>
            </div>
            <div class="clearfix mb2 my1">
              <div class="col col-12 p0" v-if="commentId === ''">
                <file-upload-input  :token="upload_token" module="quotation" :clear-file="clear_quotation_attachment" @UpdateTilbud="UpdateTilbud" :module-id="tilbud_id"></file-upload-input>
              </div>
              <div class="col col-12 p0">
                <button class="col-12 gibson action-button p2 h5 semi-bold not-rounded" type="submit" v-if="commentId === ''" :disabled="isLoadingAflyse">
                  <span>Gem</span>
                </button>
                <button class="col-12 gibson btn btn-warning p2 h5 semi-bold not-rounded" type="submit" v-if="commentId !== ''" :disabled="isLoadingAflyse">
                  <span>Rediger</span>
                </button>
                <div>
                  <b-link @click="CanceleditComment()" v-if="commentId !== ''" >Nulstil</b-link>
                </div>
              </div>
            </div>
          </b-form>
        </div>
      </div>
      <div slot="modal-footer" class="flex justify-start items-center col-12 px0">
      </div>

    </b-modal>
    <!-- cancel modal -->
    <b-modal id="modalPrevent" v-model="modalShowAflyse" ref="modal" centered class="pt3 pr3 pb1 pl3">
      <div slot="modal-title" class="hide" v-html="Aflysetitle"></div>
      <div class="clearfix">
        <p class="darkblue semi-bold gibson line-height-3 mb1" style="font-size:18.5px">Hvad skyldes reklamationen?</p>
      </div>
      <div class="clearfix">
        <b-form @submit.stop.prevent="handleSubmitAflyse">
          <div class="clearfix">
            <div class="col-12 px0">
              <b-form-textarea v-model="textAflyseReason" :rows="6" :max-rows="9" required class="border-none p2 not-rounded darkblue h5 muted-background"></b-form-textarea>
            </div>
          </div>
        </b-form>
      </div>
      <div slot="modal-footer" class="col-12 px0 flex justify-between items-center">
        <button @click="modalShowAflyse = false" class="outlined-dark-button gibson line-height-1 not-rounded p2 h5 flex justify-start items-center">
          <span class="mr2"><i class="el-icon-back"></i></span>
          <span class="mb0 semi-bold">Luk</span>
        </button>
        <button class="gibson action-button p2 h5 semi-bold not-rounded" type="submit" :disabled="isLoadingAflyse">
          <span class="mb0 semi-bold">Send</span>
          <span class="ml2"><i class="el-icon-right"></i></span>
        </button>
      </div>
    </b-modal>
    <!-- change date modal -->
    <b-modal id="modalPrevent" hide-footer v-model="modalShowDato" ref="modal" centered class="pt3 pr3 pb1 pl3">
      <form @submit.stop.prevent="handleSubmitDato" class="p2">
        <div class="h6 darkblue semi-bold gibson line-height-2 mb0 py2" v-html="Datosetitle"></div>
        <div class="clearfix mb2">
          <b-form-group id="dateStart" label="Dato" label-for="dateStart" class="mb1 darkblue semi-bold" style="font-size:16.5px;letter-spacing: -0.5px;">
            <date-picker id="dateStart" v-model="dateDato" required :config="config" class="muted-background px2 py1 border-none h6 semi-bold not-rounded" style="font-size:15px;"></date-picker>
          </b-form-group>
        </div>
        <div class="clearfix">
          <b-form-group label="Vælg tidspunkt" label-for="timeStart" class="mb1 darkblue semi-bold" style="font-size:16.5px;letter-spacing: -0.5px;">
            <b-form-select v-model="timeDato" id="select_time" required class="muted-background px2 py1 darkblue h6 semi-bold border-none" style="font-size:15px;">
            <option value="1">00:00</option>
            <option value="2">00:30</option>
            <option value="3">01:00</option>
            <option value="4">01:30</option>
            <option value="5">02:00</option>
            <option value="6">02:30</option>
            <option value="7">03:00</option>
            <option value="8">03:30</option>
            <option value="9">04:00</option>
            <option value="10">04:30</option>
            <option value="11">05:00</option>
            <option value="12">05:30</option>
            <option value="13">06:00</option>
            <option value="14">06:30</option>
            <option value="15">07:00</option>
            <option value="16">07:30</option>
            <option value="17">08:00</option>
            <option value="18">08:30</option>
            <option value="19">09:00</option>
            <option value="20">09:30</option>
            <option value="21">10:00</option>
            <option value="22">10:30</option>
            <option value="23">11:00</option>
            <option value="24">11:30</option>
            <option value="25">12:00</option>
            <option value="26">12:30</option>
            <option value="27">13:00</option>
            <option value="28">13:30</option>
            <option value="29">14:00</option>
            <option value="30">14:30</option>
            <option value="31">15:00</option>
            <option value="32">15:30</option>
            <option value="33">16:00</option>
            <option value="34">16:30</option>
            <option value="35">17:00</option>
            <option value="36">17:30</option>
            <option value="37">18:00</option>
            <option value="38">18:30</option>
            <option value="39">19:00</option>
            <option value="40">19:30</option>
            <option value="41">20:00</option>
            <option value="42">20:30</option>
            <option value="43">21:00</option>
            <option value="44">21:30</option>
            <option value="45">22:00</option>
            <option value="46">22:30</option>
            <option value="47">23:00</option>
            <option value="48">23:30</option>
          </b-form-select>
          </b-form-group>
        </div>
        <div class="clearfix mb2">
          <b-form-textarea v-model="textDatoReason" :rows="6" :max-rows="9" placeholder="Kommentarer" class="muted-background p2 darkblue semi-bold border-none gibson line-height-golden" style="font-size:15px;"></b-form-textarea>
        </div>
        <div class="clearfix mb2">
          <b-form-group id="dateStart" label="Send e-mail" label-for="Send Email" class="mb1 darkblue semi-bold" style="font-size:16.5px;letter-spacing: -0.5px;">
            <toggle-button v-model="send_email" name="send_email" :sync="true" :labels="true"/>
          </b-form-group>
        </div>
      <br />
      <div slot="modal-footer" class="col-12 px0 flex justify-between items-center">
        <button type="reset" @click="modalShowDato = false" class="col-3 outlined-dark-button gibson line-height-1 not-rounded p2 flex justify-start items-center">
            <span class="mr2"><i class="el-icon-back"></i></span>
            <span class="mb0 semi-bold">Luk</span>
          </button>
          <button class="p2 action-button flex justfiy-center items-center line-height-1 border-none not-rounded gibson" type="submit" :disabled="isLoadingDato">
            <span class="mb0">Gem</span>
            <span class="ml2"><i class="el-icon-right"></i></span>
          </button>
      </div>
      </form>
    </b-modal>
    <!-- Price feedback modal -->
    <b-modal id="priceFeedBack" v-model="modalPriceFeedback" hide-footer centered no-close-on-esc no-close-on-backdrop class="pt3 pr3 pb1 pl3">
      <div class="p2">
        <div class="flex justify-between items-center col-12 mt1 mb3 px0">
          <p class="h4 darkblue semi-bold line-height-1 gibson">
            Feedback
          </p>
          <button type="reset" @click="closePriceFeedBackModal()" class="h4 bold border-none transparent p0">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="clearfix" v-if="feedbackLoading">
          <div class="col-12">
            <div class="loader"></div>
          </div>
        </div>
        <div class="clearfix pb3" v-else>
          <div class="col-12 px0 flex justify-start" v-if="priceFeedBackData.steps != 3">
            <h1 class="semi-bold h6 primarycolor">{{statusItem.firstname}} {{statusItem.lastname}}</h1>
            <p class="primarycolor regular mb1" v-if="statusItem.mailingzip != ''">{{statusItem.mailingzip}} {{statusItem.mailingcity}}</p>
            <p class="primarycolor semi-bold mb1 invisible" v-else>.</p>
          </div>
          <div v-if="priceFeedBackData.steps == 1">
            <h3 class="h3 darkblue semi-bold gibson mt1 mb3">Hvad var det endelige tilbud?</h3>
            <p class="h5 darkblue semi-bold gibson line-height-1 gibson">Budgetprisen var:</p>
            <el-checkbox class="col-12 flex justify-start items-center p0 mb2 gibson" v-model="priceFeedBackData.priceManualChecked" @change="priceManualChanged()"><span class="darkblue h6 m0 line-height-1 inline-block">Indtast priskorrektion manuelt</span></el-checkbox>
            <el-input-number id="priceFeedBackPrice" class="primarycolor-border col-12 p0 mb3 gibson" placeholder="Pris" v-model="priceFeedBackData.price" :controls="false" :min="0" :max="500000" :disabled="priceFeedBackData.priceManualDisabled" @blur="priceFeedBackPriceChanged()"></el-input-number>
            <p class="h5 darkblue semi-bold mb3 gibson">Juster prisen her</p>
            <p class="h5 darkblue regular italic mb3 gibson">"Så kan vi blive bedre til at budgettere"</p>
            <el-slider class="col-10 p0 mx-auto mb2" v-model="priceFeedBackData.price" :min="0" :max="500000" :step="1" @change="priceFeedBackPriceChanged()"></el-slider>
            <div class="flex justify-between mb3">
              <p class="h5 primarycolor semi-bold">Lavere</p>
              <p class="h5 primarycolor semi-bold">Højere</p>
            </div>
            <div class="col-12 px0 flex justify-end">
              <button type="button" class="gibson action-button py2 px3 h5 semi-bold not-rounded" @click="priceFeedBackStep('next')">
                <span>Næste</span>
                <i class="el-icon-right"></i>
              </button>
            </div>
          </div>
          <div v-else-if="priceFeedBackData.steps == 2">
            <span class="block h3 darkblue semi-bold gibson mt1 mb3">Hvordan var din oplevelse af kunden?</span>
            <div class="col-12 px0 flex justify-between mb1">
              <p class="h5 darkblue regular gibson">Dårligt</p>
              <p class="h5 darkblue regular gibson">Godt</p>
            </div>
            <el-radio-group class="mb2 gibson" v-model="priceFeedBackData.nps" fill="#ff0000">
              <el-radio-button :label="index + 1" v-for="(radio, index) in 10" :key="index"></el-radio-button>
            </el-radio-group>
            <el-input
              type="textarea"
              :rows="5"
              placeholder="Bemærk"
              class="h5 mb3"
              v-model="priceFeedBackData.note">
            </el-input>
            <div class="col-12 flex justify-between items-center px0">
              <button type="button" class="gibson muted-button py2 px3 h5 semi-bold not-rounded mr2" @click="priceFeedBackStep('back')">
                <i class="el-icon-back"></i>
                <span>Tilbage</span>
              </button>
              <button type="button" class="gibson action-button py2 px3 h5 semi-bold not-rounded" @click="priceFeedBackStep('save')">
                <span>Gem</span>
                <i class="el-icon-right"></i>
              </button>
            </div>
          </div>
          <div class="custom-saved mt4" v-else>
            <h2 class="semi-bold">Gemt.</h2>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Survey modal -->
    <b-modal v-model="modalSurvey" hide-footer centered no-close-on-esc no-close-on-backdrop class="pt3 pr3 pb1 pl3">
      <div class="center p2">
        <div class="flex justify-end">
          <button type="reset" @click="closeSurveyModal()" class="h4 bold border-none transparent">
            X
          </button>
        </div>
        <p class="h5 primarycolor semi-bold line-height-1 mt3 mb2 gibson">
         Survey
        </p>
        <div class="clearfix" v-if="feedbackLoading">
          <div class="col-12">
            <div class="loader"></div>
          </div>
        </div>
        <div class="mb3"></div>
        <div id="surveyPopup" class="clearfix pb3 hide">
          <div class="col col-12 p0 mb4">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="Beskrivelse"
              v-model="surveyDescription">
            </el-input>
          </div>
          <div v-if="statusValue == 5">
            <div class="clearfix pb3">
              <div class="mb3">
                <p class="darkblue bold m0">Ønsker du at slette kunden?</p>
              </div>
            </div>
            <div class="flex justify-between">
              <b-button type="button" class="primarycolor-background py2 px3 m0 gibson not-rounded border-none regular col-5" @click="closeSurveyModal('no')">
                Nej
              </b-button>
              <b-button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular col-5" @click="submitSurveyDescription()">
                Ja
              </b-button>
            </div>
          </div>
          <div v-if="statusValue == 6 || statusValue == 100">
            <b-button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular col-5" @click="submitSurveyDescription()">
              Sende
            </b-button>
            </div>
          </div>
      </div>

    </b-modal>
    <!-- Confirmation modal -->
    <b-modal v-model="statusConfirmation" hide-footer centered no-close-on-esc no-close-on-backdrop class="pt3 pr3 pb1 pl3">
      <div class="center p3">
        <div class="flex justify-end">
          <button type="reset" @click="cancelRecommendInvitationnew()" class="h4 bold border-none transparent">
            X
          </button>
        </div>
        <p class="h5 primarycolor semi-bold line-height-1 mt3 mb2 gibson">
        </p>
        <div class="mb3"></div>
        <div class="clearfix pb3">
          <div class="mb3">
            <p class="darkblue bold m0">Du har valgt, at du ikke kan afgive tilbud på opgaven. <br><br>Vi vil automatisk informere kunden pr. mail, samt opgaven vil blive sendt retur til markedspladsen, så sandre kan hjælpe kunden.</p>

          </div>
        </div>
        <div class="flex justify-center">
          <b-button type="button" class="action-button  py2 px3 m0 gibson not-rounded border-none regular col-5" @click="confirmRecommendInvitationnew()">
            Bekræft
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modalSurveyikke" ref="modalSurveyikke" hide-footer centered no-close-on-esc no-close-on-backdrop class="pt3 pr3 pb1 pl3">
      <div class="center p2">
        <div class="flex justify-end">
          <button type="reset" @click="closeSurveyModalikke()" class="h4 bold border-none transparent">
            X
          </button>
        </div>
        <p class="h5 primarycolor semi-bold line-height-1 mt3 mb2 gibson">
          Survey
        </p>
        <div class="mb3"></div>
        <div id="surveyPopup" class="clearfix pb3 ">
          <div class="col col-12 p0 mb4">
            <div id="ikkeoption" class=" col-12 flex mt2 p0 ">
              <b-form-group id="nameInput" class="col-12 white-background p0" label="Vælg venligst årsagen til, hvorfor et tilbud ikke er tilgængeligt?" label-for="optionikke">
                <b-form-select  v-model="optionikke" :options="alloptionikke" class="border wizard-border col-12" required></b-form-select>
              </b-form-group>
              <el-alert v-if="showwikkeerror" title="Vælg venligst fra de fremhævede datoer" type="error" effect="light" show-icon></el-alert>
            </div>
          </div>
          <div>
            <b-button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular col-5" @click="updateStatusOther()">
              Sende
            </b-button>
            </div>
          </div>
      </div>
    </b-modal>
    <b-modal id="Reviews" ref="customerreviewsbypartners" hide-header hide-footer centered>
      <div class="col-12" v-if="reviewsloading">
        <div class="loader"></div>
      </div>
      <div class="center p2" v-else>
        <div class="flex justify-end">
          <button type="reset" @click="closereviewsmodal()" class="h4 bold border-none transparent">
            <i class="el-icon-circle-close"></i>
          </button>
        </div>
        <div v-if="allreviewsbycid.length > 0">
          <div class="flex justify-around mobile-flex-column darkblue">
            <div class="xs-col-12 sm-col-3 lg-col-3 md-col-3 highlights flex flex-column mmb3">
              <div class="my2">
                  <img :src="customerdetails.image" width="80" height="80" class="rounded-circle border">
              </div>
              <div class="center pt2 sm-hide lg-hide md-hide">
                <p class="semi-bold h4">Hej, jeg er {{customerdetails.name}}</p>
                <p class="h6">{{customerdetails.zip}}</p>
              </div>
              <div class=" py3 border border-top-0 border-left-0 border-right-0">
                  <p class="my2 h6"><span><svg id="ratings_star" data-name="ratings star" xmlns="http://www.w3.org/2000/svg" width="13.599" height="14.137" viewBox="0 0 13.599 14.137"><path id="Rectangle" d="M284.537,378.051l6.8-4.363,6.8,4.363v9.775h-13.6Z" transform="translate(-284.537 -373.688)" fill="#19a3c0"/><path id="Path_4010" data-name="Path 4010" d="M298.363,389.159l.992,2.663h2.55l-2.153,1.615,1.048,2.692-2.436-1.813-2.437,1.813,1.048-2.692-2.153-1.615h2.55Z" transform="translate(-291.563 -384.258)" fill="#fff"/></svg></span> {{allreviewsbycid.length}} reviews</p>
                  <p class="my2 h6" v-if="customerdetails.email_verified"><span><svg xmlns="http://www.w3.org/2000/svg" id="verified" width="11.479" height="14.137" viewBox="0 0 11.479 14.137"><path id="Path_1126" data-name="Path 1126" d="M5.551,14.093A14.449,14.449,0,0,1,2.8,12.2,9.771,9.771,0,0,1,.893,10.01,5.584,5.584,0,0,1,0,7.068V2.416a.422.422,0,0,1,.274-.4L5.591.027a.42.42,0,0,1,.3,0L11.2,2.021a.422.422,0,0,1,.274.4V7.068a5.584,5.584,0,0,1-.893,2.942A9.771,9.771,0,0,1,8.676,12.2a14.436,14.436,0,0,1-2.748,1.888.423.423,0,0,1-.377,0Z" transform="translate(0 0)" fill="#4dcf55"/><path id="Icon_feather-check" data-name="Icon feather-check" d="M6.8,11.872a.421.421,0,0,1-.3-.124L5.124,10.372a.422.422,0,0,1,.6-.6L6.8,10.853,9.528,8.124a.422.422,0,0,1,.6.6L7.1,11.749A.421.421,0,0,1,6.8,11.872Z" transform="translate(-1.885 -3.355)" fill="#fff"/></svg></span> Identified Verified</p>
                  <p class="my2 h6" v-if="customerdetails.payproffv2_account_id"><span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><g id="payproff" transform="translate(-743 -333)"><rect id="Rectangle_738" data-name="Rectangle 738" width="14" height="14" transform="translate(743 333)" fill="#2265fc"/><path id="Path_4030" data-name="Path 4030" d="M-1813.8,992.119h7.174a2.932,2.932,0,0,1,2.316,2.682c.092,2.235-2.316,2.8-2.316,2.8h-4.188l-1.948,1.85v-4.22h4.36l-1.4,1.391h1.4l2.478-2.42h-7.877v7.78l3.344-3.342h3.831a3.841,3.841,0,0,0,2.527-1.325,3.719,3.719,0,0,0,.9-2.516,3.854,3.854,0,0,0-.9-2.382,4.043,4.043,0,0,0-2.527-1.325h-7.174Z" transform="translate(2558.496 -656.539)" fill="#fff"/></g></svg></span> Payproff Verified</p>
              </div>
              <div class="flex flex-column items-start mt3 px3 xs-col-8 mx-auto md-col-12 lg-col-12 sm-col-12">
                  <p class="semi-bold h5 mb2">{{customerdetails.name}} confirmed</p>
                  <p class="regular font14 mb1" v-if="customerdetails.email_verified"><i class="green el-icon-check"></i> Identified</p>
                  <p class="regular font14 mb1" v-if="customerdetails.email_verified"><i class="green el-icon-check"></i> Email Address</p>
                  <p class="regular font14" v-if="customerdetails.mobile"><i class="green el-icon-check"></i> Phone Number</p>
              </div>
            </div>
            <div class="xs-col-12 sm-col-8 lg-col-8 md-col-8 highlights p0">
              <div class="py2 mx2 border border-top-0 border-left-0 border-right-0 flex flex-column justify-start items-start xs-hide ">
                <p class="semi-bold h4">Hej, jeg er {{customerdetails.name}}</p>
                <p class="h6">{{customerdetails.address}}</p>
              </div>
              <p class="my2 flex col-12 justify-start">{{allreviewsbycid.length}} reviews</p>
              <div class="px0 flex flex-column justify-start col-12">
                <div class="p2 flex flex-column items-start m0 p0" v-for="review in allreviewsbycid" :key="review.id">
                  <p class="font12 graylightcolor m0">{{moment(new Date(review.UF_REVIEW_DATE)).format('D MMMM YYYY')}}</p>
                  <p class="darkble h6 regular">{{review.UF_COMMENT}}</p>
                  <div class="flex items-center justify-start">
                    <span>
                      <img src="https://www.haandvaerker.dk/content/3.0/img/supplier/rating/customer.png" width="40" height="40" class="rounded-circle border">
                    </span>
                    <div class="flex flex-column p0 m0 items-start pl1">
                      <p class="darkble font13 regular m0">{{review.COMPANY_NAME}}</p>
                      <p class="graylightcolor font12 regular m0">{{review.COMPANY_ADDRESS}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="my4" v-else>
          Ingen anmeldelser
        </div>
      </div>
    </b-modal>
    <b-modal  centered hide-footer  id="quickandstandard" ref="quickandstandard">
        <slot name="modal-header">
          <div class="col-12 flex justify-end">
            <button type="button" @click="hideModalquickandstandard()"  class="white-button no-border not-rounded gibson ">
              <span>
              <i class="pt2 el-icon-close"></i>
              </span>
            </button>
          </div>
        </slot>
        <div class="clearfix white-background px2 m2">
          <div class="flex flex-column items-center gibson">
            <p class="h5 my1 semi-bold" >Vælg venligst</p>
            <div class="flex justify-between col-12">
            <a  type="button"  :href="'#/tilbud/upload-tilbud?app='+selectedId"  class="mr1 col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center">
              <span class="mr1">Upload Tilbud</span>
              <span><i class="el-icon-position"></i></span>
            </a>
            <a  type="button" :href="'#/tilbud/hurtigt-tilbud?app='+selectedId" class="mr1 col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center">
              <span class="mr1">Hurtigt Tilbud</span>
              <span><i class="el-icon-d-arrow-right"></i></span>
            </a>
            <a  type="button" :href="'#/tilbud/standardTilbud?app='+selectedId"  class=" col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center">
              <span class="mr1">Standard Tilbud</span>
              <span><i class="el-icon-s-custom"></i></span>
            </a>
          </div>
        </div>
      </div>
    <div slot="modal-footer" class="col-12 p2 white-background" style="height:50px;"></div>
    </b-modal>
    <b-modal hide-footer size="lg" ref="seeselectedoffer" v-model="seeselectedoffer" centered id="seeselectedoffer"  title="Hent vejledning her">
      <div class="col-12 flex justify-end items-center white-background px0 ">
        <button type="button" class="white-button no-border not-rounded " @click="closemodaloffer()">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div class="clearfix" v-if="innerloading">
        <Loading></Loading>
      </div>
      <div class="p2" v-else>
        <p class="h4 semi-bold py2 m0 ">Tilbudsliste</p>
        <div class="overflow-auto p2" style="height: 600px;">
            <div class="flex flex-column mb2 pr2" v-for="(industryfields,index) in Object.keys(selectedArr)" :key="index">
              <p class="m0 p0 h4 my1">{{parseInt(index + 1) + '. '}}{{itemsjobindustry[industryfields]}}</p>
                <!-- eslint-disable -->
                <div v-for="(jobitem,index2) in selectedArr[industryfields]" :key="index2">
                  <div class="flex items-center">
                    <p class="m0 pl3 h4 xs-pl1 my1">{{parseInt(index + 1) + '.'}}{{index2 + 1 + ' '}}{{primaryproductindustryname[jobitem['INDUSTRY']]}}</p>
                    <div class="m0 p0 lg-col-1 md-col-1 xs-col-5 sm-col-1 ml-auto ">
                      <p>{{(parseInt(jobitem['TOTAL'])).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p>
                    </div>
                  </div>
                  <div v-if="jobitem.SERIES !== null">
                    <div  v-for="(itemfields,index3) in Object.values(jobitem.SERIES)" :key="index3">
                      <div class="m0 p0 pr2 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-11 mr-auto">
                        <div class="m0 pl4 xs-pl2 flex col-12">
                          <div class="col-1 mr2">{{parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)}}</div>
                          <div class="pl1">{{itemfields.replace('- ', '')}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div  v-for="(itemfields,index3) in jobitem.SERIES_ORIGINAL" :key="index3" v-else>
                    <div class="m0 p0 pr2 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-11 mr-auto">
                      <div class="m0 pl4 xs-pl2 flex col-12">
                        <div class="col-1 mr2">{{parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)}}</div>
                        <div class="pl1">{{itemfields.replace('- ', '')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- eslint-enable -->
            </div>
            <div class="flex flex-column">
              <p class="m0 p0 mt2">Haandvaerker's Standard tekst</p>
              <div class="border round p2">
                  {{standardnote}}
              </div>
            </div>
            <div class="flex flex-column col-11 px0 mx-auto border muted-border border-bottom-0 my3 border-left-0  border-right-0 pl2">
              <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Samlet pris ekskl. moms</p><p class="m0 p0 col-8 flex justify-end">{{(parseInt(subtotaloffer)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
              <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Samlet pris inkl. moms</p><p class="m0 p0 col-8 flex justify-end">{{(parseInt(totaloffer)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
            </div> 
        </div>
      </div>
    </b-modal>
    <b-modal hide-footer size="lg" class="p3" ref="projectDescription" v-model="projectDescription" centered id="projectDescription"  title="Project description">
      <div class="col-12 flex justify-end items-center white-background px0 p2">
        <button type="button" class="white-button no-border not-rounded " @click="projectDescription = false">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div>
        <p class="semi-bold px3 mt2 h5">Job titel</p>
        <div class="py2 px3">
          <p class="line-height-golden h5 regular">{{selectedprojecttitle}}</p>
        </div>
      </div>
      <div>
        <p class="semi-bold px3 mt2 h5">Job beskrivelse</p>
        <div class="py2 px3">
          <p class="line-height-golden h5 regular">{{selectedprojectdesc}}</p>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="md" scrollable centered class="p3 notosans" @hide="closenote()" ref="viewNote" v-model="viewNote" id="viewNote"  title="Project description">
      <div class="col-12 flex justify-end items-center white-background px0">
        <button type="button" class="white-button no-border not-rounded" @click="closenote()">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div>
        <div class="p2">
          <div class="flex col-12 m0 p0 items-center mb2">
            <p class="h5 darkblue semi-bold line-height-1 m0">
              {{companyName}} <br>
              <span class="p0 font14 regular m0">Liste Dine notater : </span>
            </p>
            <button class="dark-button p1 flex items-center justify-center ml-auto" @click="addingnote = true">
              <i class="h5 m0 el-icon-circle-plus-outline"></i>
              <span class="regular">Tilføj note</span>
            </button>
          </div>
          <div class="flex flex-column m0 p0 col-12" v-if="partnernotesArr.length > 0">
            <!-- eslint-disable -->
            <div class="border light-highlights my1 px2 py1 relative" v-for="(note,index) in partnernotesArr" :key="index">
                <div class="absolute top-0 right-0 m1 pointer flex justify-around col-2 p0">
                  <!-- <p class="px1 p0 m0 primarycolor-background" @click="deletenote(note.ID)"><i class="white el-icon-edit"></i></p> -->
                  <p class="px1 p0 m0 primarycolor-background" @click="deletenote(note.ID)"><i class="white el-icon-delete"></i></p>
                </div>
                <p class="p0 m0 pt3">{{note.NOTE}}</p>
                <div class="flex flex-wrap" style="gap: 10px">
                  <img :src="image.FILE_URL" v-for="(image,index2) in note.FILES" :key="index2" @click="opengallery(note.FILES)" @error="checkimage(index2)" :id="'imagedivreview' + index2" width="60px" height="60px" class="rounded cover pointer" alt="notes images">
                </div>
            </div>
            <!-- eslint-enable -->
          </div>
          <div class="py3" v-else>
              <p class="center">Ingen noter fundet</p>
          </div>
        </div>
        <div v-if="composenoteLoading">
          <Loading></Loading>
        </div>
        <div class="p2" v-if="addingnote && !composenoteLoading">
          <el-input type="textarea" v-model="notedescription" :autosize="{ minRows: 4, maxRows: 6}" placeholder="Tilføj din note her">
          </el-input>
          <div class="mx-auto center pb2 pt3 mt2" style="border: 3px dashed rgb(25, 163, 192);" >
              <el-upload class="px3" action="#"
                  :on-change="handleFileChange"
                  :on-remove="removeImage"
                  :before-upload="beforeFileUpload"
                  :auto-upload="false"
                  accept=".jpg, .jpeg, .png, .webp"
                  :file-list="fileList"
                  list-type="picture"
                  :limit="limitUpload"
                  :multiple="true">
                  <div class="flex items-center justify-center p0">
                      <span class="mx2 relative">
                        <svg fill="#003645" width="48" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M406 195.1c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 167.7 0 222.1 0 289S54.4 410.3 121.3 410.3h84.7c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5 0-54.9 44.6-99.5 99.5-99.5 2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.2 4.9-0.4 7.5l-0.1 1.1c-0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.4 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-89.1c-6 0-10.9 4.9-10.9 10.9 0 6 4.9 10.9 10.9 10.9h89.1c59.3 0 107.6-48.3 107.6-107.6C512 243.9 464.6 196 406 195.1z"/><path d="M262.8 105.2c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 0.5 0.1 1 0.1 1.5 0.1 5.4 0 10.1-4 10.8-9.4 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 110.1 268.8 105.2 262.8 105.2z"/><path d="M312.4 320.1l-39.7-35.5c-6.8-6.1-17.2-6.1-24 0l-39.7 35.5c-4.5 4-4.9 10.9-0.9 15.4 4 4.5 10.9 4.9 15.4 0.9l26.3-23.5v134.3c0 6 4.9 10.9 10.9 10.9 6 0 10.9-4.9 10.9-10.9V312.9l26.3 23.5c2.1 1.9 4.7 2.8 7.3 2.8 3 0 6-1.2 8.1-3.6C317.3 331 316.9 324.1 312.4 320.1z"/></svg>
                      </span>
                      <span class="semi-bold">Vælg fil</span>
                  </div>
              </el-upload>
            </div>
            <div class="flex justify-end col-12 m0 p0 py1">
              <button class="action-button px2 py1 h6 " type="button" @click="submitNoteBitrix()">
                <span class="mb0">Gemme</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
            </div>
        </div>
      </div>
    </b-modal>
    <b-modal centered hide-footer hide-header id="gallerystagenew" hide-backdrop class="m0 p0" width="100%" v-model="gallerystagenew" size="xl" ref="gallerystagenew">
      <div class="lg-col-8 md-col-10 xs-p0 xs-col-12 flex justify-between items-center p0 mx-auto absolute p2 z4">
        <button class="mr-auto p0 border-none transparent pointer" @click="closengallery()">
          <i class="el-icon-back h1 white"></i>
        </button>
      </div>
      <div class="mx-auto" v-if="modalimageloading">
        <Loading></Loading>
      </div>
      <div class="flex flex-row justify-center col-12 m0 p0 height-full" v-else>
        <div class="p0 m0 col-10 mt4 pt3">
          <el-carousel :interval="4000" trigger="click" ref="galleryonenew" :setActiveItem="activestagephoto" :autoplay="false" :type="typegallery" id="galleryonenew" width="100%" indicator-position="outside">
            <el-carousel-item v-for="(item,index) in photos" :name="index.toString()" :key="index">
              <img id="imagedivreview" height="100%" class="cover pointer" :src="item.FILE_URL" width="100%" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </b-modal>
    <b-modal id="modalSurveyikkebitrix" v-model="modalSurveyikkebitrix" ref="modalSurveyikkebitrix" hide-footer centered no-close-on-esc no-close-on-backdrop class="pt3 pr3 pb1 pl3">
      <div class="col-12 flex justify-end items-center white-background p2">
        <button type="button" class="white-button no-border not-rounded " @click="closesurveyikkebitrix()">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div class="p2">
        <p class="h5 center primarycolor semi-bold line-height-1 mt3 mb2">
          Undersøgelse
        </p>
        <div class="mb3"></div>
        <div id="surveyPopup" class="clearfix pb3 ">
          <div class="col col-12 p0 mb4">
            <div id="ikkeoption" class=" col-12 flex mt2 p0 ">
              <b-form-group id="nameInput" class="col-12 white-background p0" label="Vælg venligst årsagen til, at du ikke kan afgive tilbud" label-for="optionikke">
                <b-form-select  v-model="optionikkebitrix" :options="alloptionikkebitrix" class="border wizard-border col-12" required></b-form-select>
              </b-form-group>
            </div>
            <div class="col-12 flex mt2 p0 flex flex-column" v-if="optionikkebitrix === 3">
              <p class="m0 p0 regular">Dato for at minde dig om dette kundejob</p>
              <el-date-picker v-model="cancelreminderdate" size="large" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="start" :picker-options="pickerOptions" class="px0 white-background rounded"></el-date-picker>
            </div>
          </div>
          <div class="center">
            <b-button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular col-5" @click="updateStatusOtherbitrix()">
              Indsend
            </b-button>
            </div>
          </div>
      </div>
    </b-modal>
    <b-modal v-model="quickVideoTutorialModalVisible" centered hide-footer hide-header id="quickVideoTutorialModal" size="lg">
      <div class="col-12 flex justify-end items-center white-background p2">
        <button type="button" class="white-button no-border not-rounded " @click="quickVideoTutorialModalVisible = false">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div class="col-12 p0">
        <video poster="https://www.haandvaerker.dk/imgs/afgiv_tilbud.jpg" width="100%" height="auto" controls playsinline loop autoplay muted>
          <source src="https://www.haandvaerker.dk/video/afgiv_tilbud.webm" type="video/mp4">
          <source src="https://www.haandvaerker.dk/video/afgiv_tilbud.mp4" type="video/webm">
        </video>
      </div>
    </b-modal> 
    <checkpayproff ref="checkpayproff" id="checkpayproff"></checkpayproff>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import checkpayproff from '../../components/checkpayproff'
import fileUploadInput from '../../components/file-upload-input'
import VueGallerySlideshow from 'vue-gallery-slideshow'
import { Datetime } from 'vue-datetime'
import Countdown from '../../components/Countdown'
import Countdown2 from '../../components/Countdown2'
import gql from 'graphql-tag'
import datePicker from 'vue-bootstrap-datetimepicker'
import noneligibleFeaturepop from './noneligibleFeaturepop'
import StarRating from 'vue-star-rating'
import {ImageRating} from 'vue-rate-it'
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'allmeetings',
  components: {
    loading,
    Loading,
    Countdown,
    Countdown2,
    fileUploadInput,
    VueGallerySlideshow,
    datetime: Datetime,
    Simplert,
    datePicker,
    noneligibleFeaturepop,
    StarRating,
    ImageRating,
    ErrorHandler,
    checkpayproff
  },
  created () {
    // Fagentreprise
    // Hovedentreprise
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.gettaskbitrix()
    this.getallwizardproduct()
    var mobile = this.$route.query.mobile
    if (this.$route.query.fromMarketplace) {
      this.quickVideoTutorialModalVisible = true
    }
    if (mobile !== undefined) {
      this.search = mobile
      this.$router.push('/alle-moeder')
    }
    this.env = process.env.BITRIXAPI
    this.contactID = this.$route.query.contactID
    this.projectID = this.$route.query.projectID
    this.klimaprofil = localStorage.getItem('ClimatePartner')
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    // this.getcontractlist()
    this.Reload()
    this.getPartnerImage()
    this.getSurveyId()
    this.getbrowser()
  },
  data () {
    return {
      contactID: null,
      projectID: null,
      disableStatusSelection: false,
      items: [],
      kundeitem: [],
      status: [],
      klimaprofil: '',
      SearchItem: [],
      files: [],
      statusDate: '',
      commentId: '',
      browserName: '',
      show: false,
      upload_token: '',
      clear_quotation_attachment: false,
      tilbud_id: '',
      index: null,
      modalShowPris: false,
      urlpris: '',
      datereminder: null,
      label: 'Loading...',
      service_reminder: '',
      AflyseText: '',
      search: '',
      CommentText: '',
      CommentCustomText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      komments: [],
      CommentCustomerText: '',
      showMobile: false,
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: false,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowCommentText: false,
      modalShowkomment: false,
      textKomment: '',
      modalShowFeedback: false,
      textFeedback: '',
      modalShowCommentCustomerText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      loading: true,
      salesPerson: '',
      haaId: '',
      oldestFirst: false,
      ascending: true,
      sampleMeeting: {
        id: '',
        type: '',
        estimate: '',
        city: '',
        postnummer: '',
        price: '',
        date: ''
      },
      config: {
        format: 'LL',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        debug: true,
        showClear: false,
        showClose: false
      },
      configTime: {
        format: 'HH:mm',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        // debug: true
        showClear: false,
        showClose: false
      },
      customer: {
        id: 5,
        firstName: '',
        lastName: '',
        email: ''
      },
      apollo: {
        customers: gql`query {
          customers {
            name,
            phoneNumber,
            email
          }
        }`
      },
      partnerImg: '',
      modalPriceFeedback: false,
      modalSurvey: false,
      surveyDescription: '',
      surveySteps: {
        active: 0
      },
      statusItem: [],
      statusValue: '',
      feedbackLoading: true,
      surveyId: '',
      priceFeedBackData: {
        priceManualChecked: false,
        price: 0,
        priceManualDisabled: true,
        steps: 1,
        nps: 0,
        note: ''
      },
      statusConfirmation: false,
      allyear: [],
      activeyear: '',
      optionikke: '',
      alloptionikke: [
        { value: 0, text: 'Vælg venligst en mulighed' },
        { value: 101, text: 'Kunden skal ikke have det lavet' },
        { value: 102, text: 'Jeg har for travlt og kan ikke varetage opgaven alligevel' },
        { value: 103, text: 'Projektet skal først laves langt ude i fremtiden' },
        { value: 104, text: 'Kunden ønsker først et tilbud langt ude i fremtiden' },
        { value: 105, text: 'Kunden har fået opgaven udført af en anden håndværker' }
      ],
      alloptionikkebitrix: [
        { value: 0, text: 'Vælg venligst en mulighed' }
      ],
      showwikkeerror: false,
      salesPersonbitrix: '',
      env: '',
      itemsdetails: [],
      reviewsloading: false,
      customerdetails: {
        name: '',
        email: '',
        mobile: '',
        address: '',
        image: '',
        email_verified: '',
        payproffv2_account_id: ''
      },
      allreviewsbycid: [],
      contractIds: [],
      valuestatus: {},
      valuestatuscancel: {},
      SearchItembitrix: [],
      projectIds: [],
      // tilbudstatustext: [
      //   {text: 'Ny opgave', value: '0'},
      //   {text: 'I dialog', value: '1'},
      //   {text: 'Tilbud er sendt', value: '2'},
      //   {text: 'Kan ikke afgive tilbud', value: '100'},
      //   {text: 'Vandt opgaven', value: '3'},
      //   {text: 'Opgaven er udført', value: '4'},
      //   {text: 'Ikke relevant', value: '6'}
      // ]
      selectedId: '',
      seeselectedoffer: false,
      totaloffer: 0,
      subtotaloffer: 0,
      innerloading: false,
      selectedArr: {},
      primaryproductindustryname: {},
      itemsjobindustry: {},
      standardnote: '',
      projectDescription: false,
      selectedprojecttitle: '',
      selectedprojectdesc: '',
      companyName: localStorage.getItem('CompanyName'),
      totalImageSize: '',
      limitUpload: 50,
      modalSurveyikkebitrix: false,
      notedescription: '',
      fileList: [],
      selectedjobid: '',
      selectedjobidcancel: null,
      formData: [],
      composenoteLoading: false,
      viewNote: false,
      partnernotesArr: [],
      addingnote: false,
      gallerystagenew: false,
      modalimageloading: false,
      photos: [],
      typegallery: 'none',
      activestagephoto: 0,
      optionikkebitrix: null,
      pickerOptions: {
        disabledDate (time) {
          return (time.getTime() - (-86400000)) < Date.now()
        }
      },
      cancelreminderdate: null,
      totalitems: 0,
      perPage: 20,
      lastpage: 1,
      currentpage: null,
      quickVideoTutorialModalVisible: false
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    }
  },
  watch: {
    'search': function (newVal, oldVal) {
      setTimeout(() => {
        if (newVal.length > 2 && newVal !== '' && newVal !== null) {
          this.getbitrixcustomers(1, newVal)
          this.SearchItem = []
        }
        if (newVal.length === 0) {
          this.getbitrixcustomers(1, '')
          this.SearchItem = []
        }
      }, 400)
    }
  },
  computed: {
  },
  mounted () {
    this.getyearsarray()
  },
  methods: {
    getbitrixcustomers (page = 1, searchquery = '') {
      var searpara = ''
      if (searchquery !== '') {
        searpara = '&search=' + searchquery
      }
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/jobsV3?page=' + page + '&size=' + this.perPage + searpara, { headers }, data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              if (this.projectID && this.contactID) {
                this.SearchItembitrix = res.data.data.filter(p => { return Number(p.PROJECT_ID) === Number(this.projectID) && Number(p.CUSTOMER_ID) === Number(this.contactID) })
                this.loading = false
                setTimeout(() => {
                  document.getElementById('createoffer').click()
                }, 1000)
              } else {
                this.SearchItembitrix = res.data.data
                this.totalitems = res.data.total
                this.lastpage = res.data.last_page
              }
              if (this.SearchItembitrix.length > 0) {
                this.SearchItembitrix[0].CANCEL_STATUS.forEach(p => {
                  var cancelstatuseaac = {}
                  cancelstatuseaac = {
                    value: p.ID,
                    text: p.TITLE_DK
                  }
                  this.alloptionikkebitrix.push(cancelstatuseaac)
                })
              }
              this.SearchItembitrix.forEach((j, index) => {
                // var tempstatus = j.STATUS
                j.STATUS.forEach(f => {
                  // if ((f.ID === 5 && f.IS_SELECTED) || (f.ID === 6 && f.IS_SELECTED)) {
                  //   this.SearchItembitrix[index]['STATUS'] = tempstatus.filter(o => { return o.ID !== 4 })
                  // }
                  if (f.IS_SELECTED) {
                    this.SearchItembitrix[index]['tilbudstatus'] = f.ID
                    this.SearchItembitrix[index]['tilbudstatus_text'] = f.TITLE_DK
                    this.valuestatus[index] = f.ID
                  }
                })
                // j.CANCEL_STATUS.forEach(g => {
                //   if (g.IS_SELECTED) {
                //     this.SearchItembitrix[index]['tilbudstatuscanel'] = g.ID
                //     this.SearchItembitrix[index]['tilbudstatus_textcancel'] = g.TITLE_DK
                //     this.valuestatuscancel[index] = g.ID
                //   }
                // })
                // j.SUB_PROJECTS.forEach(k => {
                //   if (k.IS_OFFER_ACCEPTED && k.IS_PARTNER) {
                //     this.SearchItembitrix[index]['haschildacceptedoffer'] = true
                //   }
                // })
              })
              // var latestyear = new Date().getFullYear()
              // if (this.activeyear === '' && this.browserName !== 'safari') {
              //   this.filteryear(latestyear)
              // }
              this.loading = false
            } else {
              this.loading = false
              this.$message({
                type: 'error',
                message: response.body.message
              })
            }
          },
          response => {
            this.loading = false
            if (response.body.message === 'Unauthorized. User has been logged out.') {
              this.refreshtoken()
              setTimeout(() => {
                this.Reload()
              }, 1000)
            } else {
              this.$message({
                type: 'error',
                message: response.body.message
              })
            }
          }
        )
    },
    paginationChanged (curPage) {
      this.currentpage = curPage
      this.SearchItembitrix = []
      this.getbitrixcustomers(curPage)
    },
    getAcceptedOfferPrice (offerid, projectid, contactid, contractType, parentid, calculationid = 0, joblist = []) {
      var submittedIndustries = []
      joblist.forEach(k => {
        if (Array.isArray(k)) {
          k.forEach(k => {
            var jobindustry = k.split(':')[0]
            submittedIndustries.push(jobindustry)
          })
        } else {
          var jobindustry = k.split(':')[0]
          submittedIndustries.push(jobindustry)
        }
      })
      var useprojid = contractType === 'Fagentreprise' || (submittedIndustries.length === 1 && submittedIndustries[0] === '1062') ? parentid : projectid
      this.selectedArr = {}
      this.totaloffer = 0
      this.subtotaloffer = 0
      this.standardnote = ''
      this.seeselectedoffer = true
      this.innerloading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinboligV2?project_id=' + useprojid + '&contact_id=' + Number(contactid) + '&calculation_id=' + calculationid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          var filteredresult = {}
          let result = res.result.filter(l => {
            if (Number(l.JOB_INDUSTRY) !== 1062) {
              return Number(l.PARTNER_ID) === Number(this.haaId) && submittedIndustries.includes(l.JOB_INDUSTRY)
            } else if (Number(l.JOB_INDUSTRY) === 1062 && submittedIndustries.length === 1) {
              return Number(l.PARTNER_ID) === Number(this.haaId) && submittedIndustries.includes(l.JOB_INDUSTRY)
            }
          })
          result.forEach(y => {
            if (!filteredresult[y.JOB_INDUSTRY]) {
              filteredresult[y.JOB_INDUSTRY] = []
              filteredresult[y.JOB_INDUSTRY].push(y)
            } else {
              filteredresult[y.JOB_INDUSTRY].push(y)
            }
            this.subtotaloffer += Number(y.TOTAL)
            this.totaloffer += Number(y.TOTALVAT)
            this.standardnote = y.NOTE
          })
          this.selectedArr = filteredresult
          this.innerloading = false
        },
        response => {
          this.innerloading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    gettaskbitrix () {
      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var industryname = {}
            res.data.forEach(l => {
              industryname[l.BRANCHE_ID] = l.BRANCHE
            })
            this.itemsjobindustry = industryname
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    getallwizardproduct () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          res.forEach(n => {
            this.primaryproductindustryname[n.producttypeid] = n.producttype
          })
        },
        err => {
          var error = err.body.message
          this.$message({
            type: 'error',
            message: error
          })
        })
    },
    getcontractlist () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contracts/contacts', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            var itemsId = []
            var itemsIdpid = []
            res.data.forEach(a => {
              itemsId.push(a.ID)
              itemsIdpid.push(parseInt(a.PROJECT_ID))
            })
            this.contractIds = itemsId
            this.projectIds = itemsIdpid
            this.Reload()
          } else {
            this.Reload()
            this.$message({
              type: 'error',
              message: response.bodymessage
            })
          }
        },
        response => {
          this.Reload()
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            // setTimeout(() => {
            //   this.getcontractlist()
            // }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        }
      )
    },
    refreshtoken () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN)
              this.salesPersonbitrix = res.data.NEW_TOKEN
            } else {
              console.log('something is wrong with refreshing the token')
              this.$router.push('/login')
            }
          },
          response => {
            console.log('something is wrong with refreshing the token')
            this.$router.push('/login')
          }
        )
    },
    getReviewIdbycustomerId (id) {
      this.$refs.customerreviewsbypartners.show()
      this.reviewsloading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/GetAllReviewsDoneByHomeOwners?customerId=' + id, { headers }, data, { emulateJSON: true }).then(
        response => {
          if (response.body.success) {
            this.customerdetails.name = response.body.data.NAME
            this.customerdetails.email = response.body.data.EMAIL
            this.customerdetails.address = response.body.data.ADDRESS
            this.customerdetails.mobile = response.body.data.MOBILE
            this.customerdetails.image = response.body.data.PICTURE
            this.customerdetails.email_verified = response.body.data.EMAIL_VERIFIED
            this.customerdetails.payproffv2_account_id = response.body.data.IS_PAYPROFF_VERIFIED
            this.allreviewsbycid = response.body.data.REVIEWS
            this.reviewsloading = false
          } else {
            this.$message({
              type: 'error',
              message: response.body.messag
            })
            this.reviewsloading = false
          }
        },
        response => {
          this.reviewsloading = false
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            // setTimeout(() => {
            //   this.getReviewIdbycustomerId()
            // }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.messag
            })
          }
        }
      )
    },
    seeTenderFile (item) {
      this.$router.push('/customer-projects/tender?projectID=' + item.PROJECT_ID + '&parentprojectID=' + item.PARENT_PROJECT.ID + '&tenderFolderID=' + (item.CONTRACT_TYPE === 'Hovedentreprise' ? item.PROJECT_TENDER_FOLDER_ID : item.PARENT_PROJECT.PROJECT_TENDER_FOLDER_ID) + '&title=' + encodeURI(item.PROJECT_NAME.replaceAll('#', '')) + '&address=' + encodeURI(item.PROJECT_ADDRESS.replaceAll('#', '')) + '&contact_id=' + item.CUSTOMER_ID + '&parent_tenderID=' + (item.PARENT_PROJECT.PROJECT_TENDER_FOLDER_ID ? item.PARENT_PROJECT.PROJECT_TENDER_FOLDER_ID : item.PROJECT_TENDER_FOLDER_ID) + '&tenderfiles=' + JSON.stringify(item.TENDER_FILES) + '&childprojects=' + JSON.stringify(item.SUB_PROJECTS) + '&joblist=' + JSON.stringify(item.JOBS_LIST) + '&contracttype=' + item.CONTRACT_TYPE + '&offerstatus=' + item.OFFER_STATUS)
      // this.$router.push('/customer-projects/tender?projectID=' + (item.PARENT_PROJECT.ID ? item.PARENT_PROJECT.ID : item.PROJECT_ID) + '&tenderFolderID=' + item.PROJECT_TENDER_FOLDER_ID + '&title=' + encodeURI(item.PROJECT_NAME.replaceAll('#', '')) + '&address=' + encodeURI(item.PROJECT_ADDRESS.replaceAll('#', '')) + '&contact_id=' + item.CUSTOMER_ID + '&parent_tenderID=' + (item.PARENT_PROJECT.PROJECT_TENDER_FOLDER_ID ? item.PARENT_PROJECT.PROJECT_TENDER_FOLDER_ID : item.PROJECT_TENDER_FOLDER_ID) + '&tenderFiles=' + item.TENDER_FILES)
    },
    updateJobsStatus (jobid, statusindex) {
      if (this.valuestatus[statusindex] === 4) {
        this.modalSurveyikkebitrix = true
        this.selectedjobidcancel = jobid
        return false
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        statusId: this.valuestatus[statusindex],
        jobId: jobid
      }
      this.$http.post(this.$bitrixapi + 'partner/updateJobStatus', data, { headers }, { emulateJSON: true }).then(
        (response) => {
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          this.getbitrixcustomers()
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    showMeetingTilbudbitrix (item, type = '') {
      if (type === 'bitrixCustomers') {
        this.selectedId = item.CUSTOMER_ID + '&projectId=' + item.PROJECT_ID + '&contactId=' + item.CUSTOMER_ID + '&name=' + item.CUSTOMER_NAME + '&email=' + item.CUSTOMER_EMAIL + '&mobile=' + item.CUSTOMER_MOBILE + '&address=' + item.PROJECT_ADDRESS
      } else if (type === 'bitrixCustomersBookingwizard') {
        this.$router.push('/tilbud/standardTilbudProduct?projectID=' + item.PROJECT_ID + '&contactID=' + item.CUSTOMER_ID + '&parentID=' + item.PARENT_PROJECT.ID + '&industryID=' + item.ENTERPRISE_INDUSTRY + '&offertype=' + item.PROJECT_OFFER_TYPE + '&childprojects=' + JSON.stringify(item.SUB_PROJECTS) + '&submittedindustry=' + JSON.stringify(item.SUBMITTED_JOB_INDUSTRY_IDS) + '&contracttype=' + item.CONTRACT_TYPE + '&projecttitle=' + item.PROJECT_NAME + '&joblist=' + JSON.stringify(item.JOBS_LIST) + '&createdfrom=' + item.CREATED_FROM)
      } else {
        this.selectedId = item.contactid
      }
      this.$refs.quickandstandard.show()
      // this.$router.push('/tilbud/standardTilbud?app=' + item.CUSTOMER_ID + '&projectId=' + item.PROJECT_ID + '&contactId=' + item.CUSTOMER_ID + '&name=' + item.CUSTOMER_NAME + '&email=' + item.CUSTOMER_EMAIL + '&mobile=' + item.CUSTOMER_MOBILE + '&address=' + item.PROJECT_ADDRESS)
    },
    hideModalquickandstandard () {
      this.$refs['quickandstandard'].hide()
    },
    showMeetingTilbudcreate (item) {
      this.$router.push('/tilbud/standardTilbud?app=' + item.contactid)
    },
    showtilbudhistory (item) {
      this.$router.push('/tilbud/tilbud-historie?app=' + item.CUSTOMER_ID + '&from=minboligv2&projectID=' + item.PROJECT_ID + '&contactID=' + item.CUSTOMER_ID + '&parentID=' + item.PARENT_PROJECT.ID + '&joblist=' + JSON.stringify(item.JOBS_LIST) + '&createdfrom=' + item.CREATED_FROM + '&contracttype=' + item.CONTRACT_TYPE + '&projecttitle=' + item.PROJECT_NAME + '&childprojects=' + JSON.stringify(item.SUB_PROJECTS) + '&offerid=' + item.OFFER_ID)
    },
    seeMessages (id, projectid = 0) {
      this.$router.push('/messages/inbox?customerId=' + id + '&projectId=' + projectid)
    },
    edittilbud (item) {
      this.$router.push('/tilbud/standardTilbudProduct?projectID=' + item.PROJECT_ID + '&contactID=' + item.CUSTOMER_ID + '&offerID=' + item.OFFER_ID + '&mode=edit&contracttype=' + item.CONTRACT_TYPE + '&joblist=' + JSON.stringify(item.JOBS_LIST) + '&parentID=' + item.PARENT_PROJECT.ID + '&offertype=' + item.PROJECT_OFFER_TYPE + '&childprojects=' + JSON.stringify(item.SUB_PROJECTS))
    },
    dataText (key, status) {
      for (var i = 0; i < status.length; i++) {
        if (status[i].value === key) {
          return status[i].text
        }
      }
      return ''
    },
    getbrowser () {
      let userAgent = navigator.userAgent
      if (userAgent.match(/chrome|chromium|crios/i)) {
        this.browserName = 'chrome'
      } else if (userAgent.match(/firefox|fxios/i)) {
        this.browserName = 'firefox'
      } else if (userAgent.match(/safari/i)) {
        this.browserName = 'safari'
        this.status = 9
        console.log('browserName', this.browserName)
      } else if (userAgent.match(/opr\//i)) {
        this.browserName = 'opera'
      } else if (userAgent.match(/edg/i)) {
        this.browserName = 'edge'
      } else {
        this.browserName = 'No browser detection'
      }
    },
    getyearsarray () {
      var initialyear = 2018
      var latestyear = new Date().getFullYear()
      for (var i = initialyear; i <= latestyear; i++) {
        this.allyear.push(initialyear)
        initialyear++
      }
      this.allyear.reverse()
    },
    filteryear (year) {
      // if (this.activeyear !== '') {
      //   var oldyear = this.activeyear
      //   // document.getElementById('yearfilter-' + oldyear).classList.add('primary-button-green')
      //   // document.getElementById('yearfilter-' + oldyear).classList.remove('green-background')
      // }
      this.activeyear = year
      // document.getElementById('yearfilter-' + year).classList.add('green-background')
      // document.getElementById('yearfilter-' + year).classList.remove('primary-button-green')
      var itemsyear = []
      var filteredyear = []
      itemsyear = this.items.filter((item) => {
        var createditemyear = new Date(item.createdtime).getFullYear()
        if (this.activeyear === 2023) {
          // if (createditemyear === year || createditemyear === 2022) {
          if (createditemyear === year) {
            return item.createdtime
          }
        } else {
          if (createditemyear === year) {
            return item.createdtime
          }
        }
      })
      itemsyear.forEach(function (value) {
        filteredyear.push(value)
      })
      this.SearchItem = this.filterSearch(filteredyear)
    },
    getdataigibility (appid, contactid) {
      if (this.klimaprofil === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.klimaprofil, '', 'ClimatePartner')
      } else {
        this.gotoKlima(appid, contactid)
      }
    },
    gotoKlima (appointmentId, contactId) {
      this.$router.push('/klima/checklist?appointmentId=' + appointmentId + '&contactId=' + contactId)
    },
    Reload () {
      if (screen.width <= 640) {
        this.showMobile = true
      } else {
        this.showMobile = false
      }
      var cid = this.$route.query.id
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1', cid: cid}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res.array
            if (this.search !== '') {
              this.updateSearch()
            } else {
              this.SearchItem = this.filterSearch(this.items)
            }
            var latestyear = new Date().getFullYear()
            if (this.activeyear === '' && this.browserName !== 'safari') {
              this.filteryear(latestyear)
            }
            this.disableStatusSelection = false
            this.getbitrixcustomers()
          },
          response => {
            this.getbitrixcustomers()
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        )
    },
    getcontract (cid) {
      if (screen.width <= 640) {
        this.showMobile = true
      } else {
        this.showMobile = false
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        cid: cid
      }
      this.$http.get(this.$bitrixapi + 'partner/contracts', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success && res.data.length > 0) {
              return true
            } else {
              return false
            }
          },
          response => {
            console.log(response)
          }
        )
    },
    onClick (item, i) {
      item.index = i
    },
    filterSearch (item) {
      return item
    },
    updateSearch () {
      var items = []
      items = this.items.filter((item) => {
        return item.firstname.toLowerCase().includes(this.search.toLowerCase()) || item.lastname.toLowerCase().includes(this.search.toLowerCase()) || item.mailingstreet.toLowerCase().includes(this.search.toLowerCase()) || item.mailingzip.toLowerCase().includes(this.search.toLowerCase()) || item.mailingcity.toLowerCase().includes(this.search.toLowerCase()) || item.email.toLowerCase().includes(this.search.toLowerCase()) || item.comment_to_partner.toLowerCase().includes(this.search.toLowerCase()) || item.comment_to_customer.toLowerCase().includes(this.search.toLowerCase()) || item.mobile.toLowerCase().includes(this.search.toLowerCase())
      })
      this.SearchItem = this.filterSearch(items)
    },
    toggleSort (statusDate) {
      var items = []
      var order
      if (statusDate === '1') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.appointment_date + ' ' + a.id_times)
          b = new Date(b.appointment_date + ' ' + b.id_times)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else if (statusDate === '2') {
        order = this.ascending ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = a.id_appointment_status
          b = b.id_appointment_status
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.ascending = !this.ascending
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.tilbud_date)
          b = new Date(b.tilbud_date)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.datereserve)
          b = new Date(b.datereserve)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else {

      }
    },
    toggleFilter (status) {
      var items = []
      var filtered = []
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          if (status[i] === '9') {
            items = this.items.filter((item) => {
              return item.privatecustomer.includes('1')
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '10') {
            items = this.items.filter((item) => {
              return item.privatecustomer.includes('0')
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] < 7 || status[i] === '100') {
            var statuscatcher = parseInt(status[i])
            items = this.items.filter((item) => {
              return item.tilbudstatus === statuscatcher
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '8') {
            items = this.items.filter((item) => {
              return item.id_appointment.length > 1
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '7') {
            items = this.items.filter((item) => {
              return item.id_appointment.length < 1
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '12') {
            items = this.items.filter((item) => {
              return item.tilbudstatus === 6
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
        }
        this.SearchItem = this.filterSearch(filtered)
      } else {
        this.SearchItem = this.filterSearch(this.items)
      }
    },
    UpdateTilbud (files) {
      this.files = files
    },
    projectdesctionopen (textdesc, texttitle) {
      this.selectedprojectdesc = ''
      this.selectedprojecttitle = ''
      this.selectedprojectdesc = textdesc
      this.selectedprojecttitle = texttitle
      this.projectDescription = true
    },
    opennotes (notes, id) {
      this.selectedjobid = id
      this.partnernotesArr = notes
      this.viewNote = true
    },
    submitNoteBitrix () {
      if (this.fileList.length < 1) {
        this.formData = new FormData()
      }
      this.composenoteLoading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.formData.append('jobId', this.selectedjobid)
      this.formData.append('note', this.notedescription)
      this.$http.post(this.$bitrixapi + 'partner/job/addNotes', this.formData, { headers }, { emulateJSON: true }).then(
        (response) => {
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          this.composenoteLoading = false
          this.formData = {}
          this.notedescription = ''
          this.addingnote = false
          this.closenote()
          this.getbitrixcustomers()
        },
        (response) => {
          this.composenoteLoading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    handleFileChange (file, fileList) {
      const isLt1M = file.size / 1000 / 1000 < 7
      const isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp'
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 5 MB!'
        })
        let index = this.fileList.indexOf(file.key)
        this.fileList.splice(index, 1)
        return false
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        })
        let index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
        return false
      }
      this.fileList = fileList.slice(0)
      this.formData = new FormData()
      for (var image in fileList) {
        this.formData.append('files[]', fileList[image].raw)
      }
    },
    closenote () {
      this.partnernotesArr = []
      this.fileList = []
      this.formData = {}
      this.addingnote = false
      this.viewNote = false
      this.selectedjobid = null
    },
    deletenote (noteid) {
      this.$confirm('Er du sikker på, at du vil slette denne note?', {
        confirmButtonText: 'Ja tak',
        cancelButtonText: 'Nej tak',
        type: 'warning'
      }).then(() => {
        this.composenoteLoading = true
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        this.$http.post(this.$bitrixapi + 'partner/job/' + this.selectedjobid + '/deleteNotes/' + noteid, this.formData, { headers }, { emulateJSON: true }).then(
          (response) => {
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
            this.composenoteLoading = false
            this.addingnote = false
            this.closenote()
            this.getbitrixcustomers()
          },
          (response) => {
            this.composenoteLoading = false
            var error = response.body.message
            this.$message({
              type: 'error',
              message: error
            })
          }
        )
      })
    },
    checkimage (index) {
      // var image = 'https://haandvaerker.dk/uploads/00.webp'
      var image2 = 'https://photo.haandvaerker.dk/photos/minbolig/3130899/payment-stages-181-20220826060242JEG.webp'
      var getimage = document.getElementById('imagedivreview' + index)
      getimage.src = image2
    },
    closengallery () {
      this.photos = []
      this.gallerystagenew = false
    },
    opengallery (images, index = '', index2 = '') {
      this.photos = []
      this.photos = images
      this.gallerystagenew = true
      this.typegallery = this.showMobile ? 'none' : 'card'
      setTimeout(() => {
        document.getElementById('gallerystagenew___BV_modal_body_').style.width = window.innerWidth + 'px'
        document.getElementById('sidebarphoto').style.height = parseInt(window.innerHeight - 150) + 'px'
        document.getElementById('gallerystagenew___BV_modal_body_').style.padding = 0 + 'px'
      }, 200)
    },
    prisUrlOpen (item) {
      this.modalShowPris = true
      this.urlpris = item.potentialnameurl
    },
    prisUrlOpendato (item) {
      this.modalShowPris = true
      this.urlpris = item.changedateurl
    },
    prisUrlOpenFile (item) {
      this.modalShowPris = true
      this.urlpris = item.potentialnameurl + '&file=1'
    },
    handleSletReminder (item, type) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'delete_reminder_meeting', salesPerson: this.salesPerson, appointmentid: item.id_appointment, type: type}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.show = false
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.Reload()
              this.$refs.simplert.openSimplert(obj)
              this.datereminder = null
            } else {
              alert(res.message)
              this.isLoadingDato = false
            }
          },
          response => {
            this.show = false
            alert('error')
          }
        )
    },
    handleSubmitReminder (item) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var smsemail = item.remiderappid.smsemail
      var dateReminder = this.datereminder
      var descp = item.remiderappid.descp
      if (dateReminder === '' || dateReminder === null) {
        let obj = {
          title: 'Påmindelse Dato ?',
          message: '',
          type: 'error'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      this.show = true
      var data = {operation: 'change_reminder_meeting', salesPerson: this.salesPerson, smsemail: smsemail, appointmentid: item.id_appointment, date_reminder: dateReminder, descp: descp}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.show = false
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.Reload()
              document.getElementById('setReminderb' + item.id_appointment).click()
              this.$refs.simplert.openSimplert(obj)
              this.datereminder = null
            } else {
              alert(res.message)
              this.isLoadingDato = false
            }
          },
          response => {
            this.show = false
            alert('error')
          }
        )
    },
    handleSubmitDato () {
      this.isLoadingDato = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var emailpartner = 1
      var idTime = $('#select_time').val()
      var time = $('#select_time :selected').text()
      var emailcustomer = this.send_email ? 1 : 0
      var data = {operation: 'change_date', salesPerson: this.salesPerson, appointmentid: this.Datoeid.id_appointment, changedesc: this.textDatoReason, emailcustomer: emailcustomer, datechooseqbook: this.dateDato, id_time: idTime, time: time, emailpartner: emailpartner}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Datoeid.appointment_date = this.dateDato
              this.dateDato = ''
              this.Datoeid.id_times = time
              this.isLoadingDato = false
            } else {
              alert(res.message)
              this.isLoadingDato = false
            }
          },
          response => {
            alert('error')
          }
        )
    },
    handleSubmitAflyse () {
      this.isLoadingAflyse = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'aflyse', salesPerson: this.salesPerson, appointmentid: this.Aflyseid.id_appointment, aflysedesc: this.textAflyseReason, ticket: 2}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowAflyse = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Aflyseid.id_appointment_status_support = '1'
              this.Aflyseid.ticketsolution = ''
              this.Aflyseid.ticketstatus = 'Afventer behandling'
              this.Aflyseid.ticketcategory = 'Reklamation'
            } else {
              alert(res.message)
              this.isLoadingAflyse = false
            }
          },
          response => {
            alert('error')
          }
        )
    },
    handleSubmitFeedback () {
      this.isLoadingAflyse = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'addfeedback', salesPerson: this.salesPerson, feedback: this.textFeedback, id_appointment: this.kundeitem.id_appointment}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.$toastr('success', 'Gennemført')
              this.textFeedback = ''
              this.isLoadingAflyse = false
              this.modalShowFeedback = false
            } else {
              alert(res.message)
              this.isLoadingAflyse = false
            }
          },
          response => {
            alert('error')
            this.isLoadingAflyse = false
          }
        )
    },
    handleSubmitComment () {
      this.loading = true
      this.modalShowkomment = false
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'addcomment', salesPerson: this.salesPerson, files: JSON.stringify(this.files), comment: this.textKomment, cid: this.kundeitem.contactid, commentId: this.commentId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.$toastr('success', 'Gennemført')
              this.textKomment = ''
              this.commentId = ''
              this.files = []
              this.loadComment()
              this.Reload()
              this.isLoadingAflyse = false
            } else {
              alert(res.message)
              this.isLoadingAflyse = false
            }
          },
          response => {
            alert('error')
            this.isLoadingAflyse = false
          }
        )
    },
    loadComment () {
      this.loading = true
      var data = {operation: 'loadcomment', salesPerson: this.salesPerson, cid: this.kundeitem.contactid}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.komments = res
            this.loading = false
          },
          response => {
            alert('error')
            this.loading = false
          }
        )
    },
    showMeetingTilbud (item) {
      this.$router.push('/tilbud/tilbud-historie?app=' + item.contactid)
    },
    showprojectdash (item) {
      this.$router.push('/customer-projects/project-dashboard?projectId=' + item.PROJECT_ID + '&contactID=' + item.CUSTOMER_ID + '&parentID=' + item.PARENT_PROJECT.ID + '&industryID=' + item.ENTERPRISE_INDUSTRY + '&offertype=' + item.PROJECT_OFFER_TYPE + '&childprojects=' + JSON.stringify(item.SUB_PROJECTS) + '&submittedindustry=' + JSON.stringify(item.SUBMITTED_JOB_INDUSTRY_IDS) + '&contracttype=' + item.CONTRACT_TYPE + '&projecttitle=' + item.PROJECT_NAME)
    },
    showMeetingDetailsAflysetext (item) {
      this.modalShowAflyseText = true
      this.AflyseText = item.ticketsolution
      this.AflyseTexttitle = item.ticketstatus
    },
    showMeetingDetailsCommenttext (item) {
      this.modalShowCommentText = true
      this.CommentText = item.comment_to_partner
    },
    showMeetingDetailsCommentCustomertext (item) {
      this.modalShowCommentCustomerText = true
      this.CommentCustomerText = item.comment_to_customer
    },
    showMeetingDetailsDate  (item) {
      this.Datosetitle = 'Ændring af tid for kunde: ' + item.firstname + ' ' + item.lastname
      this.modalShowDato = true
      this.Datoeid = item
      this.textDatoReason = ''
      this.isLoadingDato = false
      var select = document.getElementById('select_time')
      for (var i = 0; i < select.length; i++) {
        var option = select.options[i]
        if (option.text === item.id_times) {
          this.timeDato = option.value
        }
      }
    },
    showikkeform () {
      this.$refs.modalSurveyikke.show()
    },
    closeSurveyModalikke () {
      this.$refs.modalSurveyikke.hide()
    },
    changeStatus (value, item) {
      this.statusValue = value
      this.statusItem = item
      this.disableStatusSelection = true
      // Price feedback
      if (value === '2' || value === '3' || value === '4') {
        if (item.pricefeedback === '0') {
          this.feedbackLoading = true
          this.showPriceFeedBackModal()
        } else {
          this.updateStatus(value, item)
        }
      // Survey feedback
      } else if (value === '5' || value === '6') {
        this.feedbackLoading = true
        this.showSurveyModal()
      } else if (value === '100') {
        this.showikkeform()
      } else {
        this.updateStatus(value, item)
      }
    },
    updateStatusOther () {
      var item = this.statusItem
      var valueid = this.optionikke
      var dataPartner = {
        operation: 'customer_other_status_henttilbud',
        salesPerson: this.salesPerson,
        status: valueid,
        cid: item.id_appointment
      }
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            this.updateStatus(100, item)
            this.closeSurveyModalikke()
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          },
          response => {
            console.log('Error in updateStatus()', response)
          }
        )
    },
    updateStatusOtherbitrix (jobid = 0) {
      if (this.optionikkebitrix === null || this.optionikkebitrix === 0) {
        this.$message({
          type: 'error',
          message: 'Vælg venligst fra de fremhævede datoer'
        })
        return false
      }
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        cancelStatusId: this.optionikkebitrix,
        jobId: this.selectedjobidcancel
      }
      if (this.cancelreminderdate !== null) {
        data.reminderDate = this.cancelreminderdate
      }
      this.$http.post(this.$bitrixapi + 'partner/job/cancel', data, { headers }, { emulateJSON: true }).then(
        (response) => {
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          this.closesurveyikkebitrix()
          this.getbitrixcustomers()
        },
        (response) => {
          this.loading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    closesurveyikkebitrix () {
      this.modalSurveyikkebitrix = false
      this.selectedjobidcancel = null
    },
    updateStatus (value, item) {
      this.modalPriceFeedback = false
      this.modalSurvey = false
      this.isLoadingReview = true
      var dataPartner = {operation: 'customer_status_henttilbud', salesPerson: this.salesPerson, status: value, cid: item.id_appointment, descp: this.surveyDescription}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingReview = false
            this.surveyDescription = ''
            var infoType = ''
            if (res.success) {
              infoType = 'success'
            } else {
              infoType = 'info'
            }
            let obj = {
              title: res.message,
              message: '',
              type: infoType,
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
            this.Reload()
          },
          response => {
            console.log('Error in updateStatus()', response)
          }
        )
    },
    submitSurveyDescription () {
      if (this.surveyDescription !== '') {
        var value = this.statusValue
        var item = this.statusItem
        if (value === '100') {
          this.modalSurvey = false
          var thisVar = this
          setTimeout(function () {
            thisVar.statusConfirmation = true
          }, 1000)
        } else {
          this.updateStatus(value, item)
        }
      } else {
        this.$toastr('error', 'Felter påkrævet')
      }
    },
    feedbackLoaded () {
    },
    priceManualChanged () {
      if (this.priceFeedBackData.priceManualChecked) {
        this.priceFeedBackData.priceManualDisabled = false
      } else {
        this.priceFeedBackData.priceManualDisabled = true
      }
    },
    getSurveyId () {
      var data = {operation: 'partner_survey', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.surveyId = res.url
          },
          response => {
            console.log('Error in getSurveyId()', response)
          }
        )
    },
    showPriceFeedBackModal () {
      this.modalPriceFeedback = true
      var thisVar = this
      setTimeout(function () {
        thisVar.feedbackLoading = false
      }, 1000)
    },
    closePriceFeedBackModal () {
      var value = this.statusValue
      var item = this.statusItem
      if (value === '4') {
        setTimeout(function () {
          var buttonRecommendation = document.getElementById('recommendInvitation-' + item.id_appointment)
          buttonRecommendation.click()
        }, 1000)
      } else {
        this.updateStatus(value, item)
      }
      this.modalPriceFeedback = false
      this.priceFeedBackData.priceManualChecked = false
      this.priceFeedBackData.price = 0
      this.priceFeedBackData.priceManualDisabled = true
      this.priceFeedBackData.steps = 1
      this.priceFeedBackData.nps = 0
      this.priceFeedBackData.note = ''
    },
    showSurveyModal () {
      this.modalSurvey = true
      var thisVar = this
      setTimeout(function () {
        thisVar.feedbackLoading = false
        document.querySelector('#surveyPopup').classList.remove('hide')
      }, 1000)
    },
    closeSurveyModal () {
      // var value = this.statusValue
      // if (value === '100') {
      //   // var thisVar = this
      //   // setTimeout(function () {
      //   //   thisVar.statusConfirmation = true
      //   // }, 1000)
      // } else if (value === '5') {
      //   // this.cancelDidNotWinTask()
      //   // setTimeout(function () {
      //   //   var buttonDidNotWinTask = document.getElementById('didNotWinTask-' + item.id_appointment)
      //   //   buttonDidNotWinTask.click()
      //   // }, 1000)
      // } else {
      //   this.Reload()
      // }
      this.surveyDescription = ''
      this.Reload()
      this.modalSurvey = false
    },
    closereviewsmodal () {
      this.$refs.customerreviewsbypartners.hide()
    },
    getPartnerImage () {
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.resultImages.length !== 0) {
              this.partnerImg = res.resultImages[0].FileLocation
            }
          },
          response => {
            alert('error')
          }
        )
    },
    confirmRecommendInvitation (value, item, answer) {
      if (answer === 'yes') {
        return dialog => this.sendRecommendInvitation(value, item)
      } else {
        return dialog => this.dontSendRecommendInvitation(value, item)
      }
    },
    confirmRecommendInvitationnew () {
      var value = this.statusValue
      var item = this.statusItem
      this.statusConfirmation = false
      this.updateStatus(value, item)
    },
    cancelRecommendInvitationnew () {
      this.Reload()
      this.surveyDescription = ''
      this.statusConfirmation = false
    },
    // confirmDidNotWinTask (answer) {
    //   if (answer === 'yes') {
    //     this.submitSurveyDescription()
    //   } else {
    //     this.cancelDidNotWinTask()
    //   }
    // },
    // dontSendRecommendInvitationnew () {
    //   let obj = {
    //     title: 'Gennemført',
    //     message: '',
    //     type: 'success',
    //     customCloseBtnText: 'Luk'
    //   }
    //   this.$refs.simplert.openSimplert(obj)
    //   this.Reload()
    // },
    sendRecommendInvitation (value, item) {
      var customers = []
      customers.push({
        name: item.firstname + ' ' + item.lastname,
        email: item.email,
        mobile: item.mobile
      })
      var data = {
        operation: 'service_invite_action',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        customers: JSON.stringify(customers),
        imgPicked: this.partnerImg,
        bcc: '0'
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.updateStatus(value, item)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    dontSendRecommendInvitation (value, item) {
      this.updateStatus(value, item)
    },
    cancelDidNotWinTask () {
      this.Reload()
      this.modalSurvey = false
    },
    showMeetingDetailsAflyse (item) {
      this.Aflysetitle = 'Er mødet med ' + item.firstname + ' ' + item.lastname + ' aflyst af kunden?'
      this.modalShowAflyse = true
      this.Aflyseid = item
      this.textAflyseReason = ''
      this.isLoadingAflyse = false
    },
    filterItem (items) {
      var newItem = []
      for (var iteme in items) {
        newItem.push(items[iteme])
      }
      return newItem
    },
    showMeetingDetails (item) {
      this.meetingShow = !this.meetingShow
      this.sampleMeeting.id = item.id
      this.sampleMeeting.type = item.type
      this.sampleMeeting.estimate = item.estimate
      this.sampleMeeting.city = item.city
      this.sampleMeeting.postnummer = item.postnummer
      this.sampleMeeting.price = item.price
      this.sampleMeeting.date = item.date
    },
    hideModal () {
      this.$refs.meetingModal.hide()
    },
    mailSupport (cid) {
      this.$router.push('/inbox?cid=' + cid)
    },
    openFeedback (item) {
      this.kundeitem = item
      this.loadComment()
      this.isLoadingAflyse = false
      this.modalShowFeedback = true
    },
    openComment (item) {
      this.kundeitem = item
      this.loadComment()
      this.isLoadingAflyse = false
      this.modalShowkomment = true
      this.commentId = ''
      this.textKomment = ''
    },
    editComment (item) {
      this.commentId = item.id
      this.textKomment = item.note
    },
    CanceleditComment () {
      this.commentId = ''
      this.textKomment = ''
    },
    hideReminderModal () {
      this.$refs.reminderModal.hide()
    },
    priceFeedBackPriceChanged () {
      var price = document.querySelector('#priceFeedBackPrice input').value
      if (!price.includes('kr')) {
        document.querySelector('#priceFeedBackPrice input').value = (parseFloat(price)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})
      }
    },
    priceFeedBackStep (option) {
      if (option === 'back') {
        if (this.priceFeedBackData.steps > 0) {
          this.priceFeedBackData.steps--
        }
      } else if (option === 'next') {
        if (this.priceFeedBackData.price > 0) {
          if (this.priceFeedBackData.steps < 2) {
            this.priceFeedBackData.steps++
          }
        } else {
          this.$toastr('error', 'Indtast venligst beløb')
        }
      } else {
        if (this.priceFeedBackData.nps > 0) {
          this.feedbackLoading = true
          this.saveFeedBackPrice()
        } else {
          this.$toastr('error', 'Felter påkrævet')
        }
      }
    },
    saveFeedBackPrice () {
      var shortUrl = this.statusItem.urlshort
      var url = 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=savefeedback&short=' + shortUrl
      var potentialId = this.statusItem.potential_id
      var price = this.priceFeedBackData.price
      var data = {
        potential_id: potentialId,
        price: price
      }
      this.$http.post(url, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.saveFeedBackNps()
          } else {
            this.feedbackLoading = false
            console.log('Error in saveFeedBackPrice()', response)
          }
        },
        (response) => {
          this.feedbackLoading = false
          console.log('Error in saveFeedBackPrice()', response)
        }
      )
    },
    saveFeedBackNps () {
      var shortUrl = this.statusItem.urlshort
      var url = 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=savefeedbacknps&short=' + shortUrl
      var potentialId = this.statusItem.potential_id
      var note = this.priceFeedBackData.note
      var nps = this.priceFeedBackData.nps
      var data = {
        potential_id: potentialId,
        note: note,
        nps: nps
      }
      this.$http.post(url, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.priceFeedBackData.steps = 3
            this.feedbackLoading = false
          } else {
            this.feedbackLoading = false
            console.log('Error in saveFeedBackNps()', response)
          }
        },
        (response) => {
          this.feedbackLoading = false
          console.log('Error in saveFeedBackNps()', response)
        }
      )
    },
    closemodaloffer () {
      this.selectedArr = {}
      this.totaloffer = 0
      this.seeselectedoffer = false
    },
    beforeFileUpload (file) {
      const isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp'
      const isLt1M = file.size / 1000 / 1000 < 17
      this.checkImageSizes()
      for (var i = 0; i < this.fileListTemp.length; i++) {
        if (this.fileListTemp[i].name === file.name) {
          this.$message({
            type: 'error',
            message: 'Kan ikke uploade det samme billede!'
          })
          return false
        }
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        })
        let index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
        return false
      }
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 15 MB!'
        })
        let index = this.fileList.indexOf(file.key)
        this.fileList.splice(index, 1)
        return false
      }
      return isIMAGE && isLt1M
    },
    checkImageSizes () {
      var fileSize = 0
      for (var i = 0; i < this.fileList.length; i++) {
        fileSize = Number(fileSize) + Number(this.fileList[i].size)
      }
      if (fileSize > 17000000) {
        this.limitUpload = this.fileList.length
        // this.$message.error("Den samlede størrelse af billeder oversteg 30 MB.");
      } else {
        this.limitUpload = 50
      }
      this.totalImageSize = fileSize
    },
    removeImage (file, fileList) {
      const index = fileList.indexOf(file)
      if (index > -1) {
        this.fileList.splice(index, 1)
      }
      const index2 = fileList.indexOf(file.raw)
      if (index2 > -1) {
        this.images.splice(index2, 1)
      }
    }
  }
}
</script>
<style>
/* .el-tooltip__popper {
  width: 400px!important;
}  */
#viewNote .el-upload-list__item-name [class^=el-icon] {
  display: none;
}
#modalSurveyikkebitrix .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}
#mycustomer {
  height:100vh;
}
#mycustomer .collapsebutton {
  border: 1px solid #134553;
  border-radius: 3px;
}
#mycustomer .font14 {
  font-size: 14px;
}
#mycustomer .el-select__caret {
  background-color: #fff!important;
  border: 0px!important;
  height: calc(1.7rem + 2px)!important;
  margin-top: 6px!important;
}
#mycustomer .font13 {
  font-size: 13px;
}
#Reviews .modal-dialog {
  max-width: 950px;
}
#Reviews .font12 {
  font-size: 12px;;
}
#Reviews .font10 {
  font-size: 10px;;
}
#Reviews .font14 {
  font-size: 14px;;
}
#Reviews .font13 {
  font-size: 13px;;
}
#Reviews .graylightcolor {
  color: #00364580;
}
#mycustomer .el-input__inner {
  background-color: #fff;
  border-color: #9393935c;
  height: 40px;
  font-size: 14px !important;
  border-radius: 3px;
  font-weight: 600;
  color: #003645
}
#mycustomer .custom-select {
  padding: 0px;
  height: 40px!important;
  width: 90%;
  padding-left: 10px;
  font-size: 15px;
}
#mycustomer .el-select__caret {
  display: inline-block;
    max-width: 100%;
    height: calc(2.25rem + 2px);
    padding: 0;
    line-height: 1.25;
    color: #3e515b;
    vertical-align: middle;
    background: rgb(219, 225, 227) url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right 0.75rem center;
    background-size: 8px 10px;
    border: 1px solid rgb(219, 225, 227);
    border-radius: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
#mycustomer .el-input__icon:after{
  display: none;
}
#mycustomer .el-input__icon:before{
  display: none;
}
#mycustomer .el-select__caret.is-reverse {
  transform: none!important;
}
#mycustomer .el-select .el-input .el-select__caret {
    transition: none;
    -webkit-transform: none;
    transform: none;
}

#mycustomer .dg-content{
  white-space:pre-wrap;
}
#mycustomer .custom-control-input {
    position: unset;
    z-index: 1;
    opacity: 1;
    margin-right: 14px;
}
#mycustomer  .image {
    width: 200px;
    height: 200px;
    background-size: contain;
    cursor: pointer;
    margin: 10px;
    border-radius: 3px;
}
#mycustomer .field-input {
  border-radius: 0!important;
  background: rgba(230, 234, 235, 0.5)!important;
  border:0!important;
}

#mycustomer .kundebutton {
  height: 50px;
}

#mycustomer .prisverslag .modal-content {
  min-height: 80vh;
}
#mycustomer  .searchContainer {
  position: relative;
  overflow: hidden;
}
#mycustomer .searchIcon {
  padding: 0.5rem;
}
#mycustomer .searchBox {
  border: 0;
  flex: 1;
  outline:none;
}
#mycustomer ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgba(47, 54, 64, 0.5);
}
#mycustomer ::-moz-placeholder { /* Firefox 19+ */
  color: rgba(47, 54, 64, 0.5);
}
#mycustomer :-ms-input-placeholder { /* IE 10+ */
  color: rgba(47, 54, 64, 0.5);
}
#mycustomer :-moz-placeholder { /* Firefox 18- */
  color: rgba(47, 54, 64, 0.5);
}
#mycustomer .switch.switch-text .switch-label {
  border: 0;
  background-color: lighten(grey, 17%);
}
#mycustomer .switch.switch-text .switch-handle {
  border:0;
}
#mycustomer .modal-footer {
  border-top: 0;
}
#mycustomer .modal-header {
  border-bottom:0;
  padding-bottom:0;
}
#mycustomer .henttilbud {
  border: 1px dashed #3FC380!important;
  padding: 4px;
}
#mycustomer .card-header {
  border-top: 0;
  border-bottom: 0;
  font-weight: 700;
}
#mycustomer .modal-dialog ul > li > span {
  word-break: break-word;
}
#dineNotater .vgs__container {
  background-color: #fff;
}
#dineNotater .vgs__close {
  color: #000;
  font-size: 2.5rem;
}
#priceFeedBack .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-color: #000;
}
#priceFeedBack .el-checkbox__inner::after {
  width: 4px;
  height: 10px;
  left: 7px;
}
#priceFeedBack span.el-checkbox__label {
  font-size: 1.25rem;
  font-weight: 600;
  color: #19a3c0;
}
#priceFeedBack .el-input-number {
  border: 1px solid;
  border-color: #19a3c0;
  border-radius: 6px;
  width: 100%;
}
#priceFeedBack .el-input-number input {
  font-size: 1.3rem;
  font-weight: 600;
  padding: 2.5rem 2rem;
  color: #19a3c0;
}
#priceFeedBack .el-slider__bar {
  height: 12px;
  border-radius: 5px;
}
#priceFeedBack .el-slider__runway {
  height: 12px;
  border-radius: 5px;
}
#priceFeedBack .el-slider__button {
  width: 20px;
  height: 20px;
  background-color: #409EFF;
}
#priceFeedBack .el-slider__button-wrapper {
  top: -12px;
}
#priceFeedBack .el-radio-button__inner {
  font-size: 1.4rem;
  color: #19a3c0;
  border-color: #19a3c0;
  padding: 12px 20px;
  border: 1px solid #19a3c0;
  border-left: 0;
}
#priceFeedBack .el-radio-button:first-child .el-radio-button__inner {
  border-left: 1px solid #19a3c0;
}
#priceFeedBack .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #fff;
}
#priceFeedBack .el-textarea textarea {
  border-color: #19a3c0;
}
#priceFeedBack .custom-saved {
  color: #3c763d;
  font-weight: 600;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  padding: 3rem 2rem;
}
@media screen and (max-width: 640px) {
  .card {
    min-width: 100%;
    margin-bottom: 24px;
  }
  #priceFeedBack .el-radio-button {
    border-left: 1px solid #19a3c0;
    border-radius: 2px;
  }
}
#mycustomer  .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#mycustomer  .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#mycustomer  .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#mycustomer  .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#mycustomer  .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
#Reviews  .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#Reviews  .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#Reviews  .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#Reviews  .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#Reviews  .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
#gallerystagenew .el-carousel__item--card.is-active {
  display: block;
}
#gallerystagenew .el-carousel__item {
  display: block;
}
#gallerystagenew .el-carousel__item--card {
  width: 65%;
}
#gallerystagenew .el-upload-list {
  display: none;
}
#gallerystagenew___BV_modal_content_ {
    height: 100%;
}
#gallerystagenew___BV_modal_content_ .el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
#gallerystagenew .modal-dialog {
  width: 100%;
  height: 100%;
  margin: 0px;
  margin-left: inherit;
}
#gallerystagenew .el-carousel__indicator {
  display: none;
}
#gallerystagenew___BV_modal_content_ .el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
#gallerystagenew___BV_modal_content_ {
  background: transparent!important;
}
#gallerystagenew___BV_modal_content_ .modal-content{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
#galleryonenew .el-carousel__container {
  height: 750px;
}
#gallerystagenew___BV_modal_body_  {
  margin-right: auto;
  margin-left: auto;
}
#gallerystagenew___BV_modal_content_ .el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
@media (max-width:40em) {
  #Reviews .mobile-flex-column {
    flex-direction: column!important;
    align-items: center;
  }
  #Reviews .mmb3 {
    margin-bottom: 2rem;
  }
  #galleryonenew .el-carousel__container {
      height: 345px;
  }
  #gallerystagenew .el-carousel__arrow {
    display: block!important;
  }
}
</style>



// WEBPACK FOOTER //
// AllMeetingsTable.vue?21235c38